"use client"

import { useLanguage } from "../context/LanguageContext"

export const translations = {
  es: {
    // Suscripción IA
    aiSubscription: "Suscripción IA",
    aiActivateTitle: "Activa la Inteligencia Artificial",
    aiActivateSubtitle: "Desbloquea los módulos de IA de miabc para crear lecturas, cuestionarios y actividades automáticamente.",
    aiActiveTitle: "Tu suscripción de IA está activa 🎉",
    aiActiveSubtitle: "Ya puedes usar todos los módulos de IA.",
    aiValidUntil: "Vigente hasta",
    manageSubscription: "Gestionar suscripción",
    manageLocalNote: "Suscripción por Pago Móvil/Transferencia. Para cambios o renovación, contáctanos.",
    onboardingTitle: "¡Bienvenido a miabconline!",
    onboardingSubtitle: "Aún no has registrado a tu aprendiz. Sigue estos pasos para empezar.",
    onboardingCodeLabel: "Tu código de acceso",
    onboardingStep1: "Descarga la app MIABC en tu teléfono o tablet.",
    onboardingStep2: "Crea el perfil de tu aprendiz usando el código de acceso de arriba.",
    onboardingStep3: "Vuelve aquí y presiona “Ya registré a mi aprendiz” para ver su progreso.",
    onboardingDownloadApp: "Google Play",
    onboardingEnter: "Ya registré a mi aprendiz",
    onboardingHelp: "¿Necesitas ayuda? Escríbenos y con gusto te guiamos.",
    portalError: "No se pudo abrir el portal de gestión.",
    payWithLocal: "¿En Venezuela? Paga con Pago Móvil / Transferencia",
    choosePaymentMethod: "Elige cómo pagar",
    payCardTitle: "Tarjeta",
    payCardDesc: "Pago internacional con tarjeta. Se activa al instante.",
    payCardBadge: "Inmediato",
    payLocalTitle: "Pago Móvil o transferencia",
    payLocalDesc: "Desde tu banco en Venezuela. Se activa al verificar tu comprobante.",
    payLocalBadge: "Venezuela",
    localPaymentTitle: "Pago Móvil / Transferencia",
    localPaymentSubtitle: "Paga desde Venezuela y activamos tu suscripción al verificar el comprobante.",
    payToAccount: "Paga a esta cuenta",
    referencePrice: "Precio de referencia",
    selectPlan: "Selecciona el plan",
    paymentReference: "N.º de referencia",
    originBank: "Banco de origen",
    amountPaid: "Monto pagado",
    paymentDate: "Fecha del pago",
    uploadProof: "Sube el comprobante",
    proofHint: "Imagen del pago (captura o foto).",
    submitPayment: "Enviar comprobante",
    proofRequired: "Debes subir el comprobante.",
    proofUploadError: "No se pudo subir el comprobante. Intenta de nuevo.",
    paymentUnderReviewTitle: "Pago en revisión",
    paymentUnderReviewText: "Recibimos tu comprobante. Activaremos tu suscripción al verificarlo (usualmente en pocas horas).",
    adminPaymentsTitle: "Pagos por conciliar",
    statusPending: "Pendientes",
    statusConfirmed: "Confirmados",
    statusRejected: "Rechazados",
    notAuthorized: "No autorizado.",
    noPayments: "No hay pagos para mostrar.",
    viewProof: "Ver comprobante",
    confirmPayment: "Confirmar",
    rejectPayment: "Rechazar",
    rejectReasonPrompt: "Motivo del rechazo (opcional)",
    paymentConfirmed: "Pago confirmado y suscripción activada.",
    paymentRejected: "Pago rechazado.",
    adminSchoolsTitle: "Escuelas",
    adminLeadsTitle: "Solicitudes de escuelas",
    leadNew: "Nuevas",
    leadContacted: "Contactadas",
    leadConverted: "Convertidas",
    leadDiscarded: "Descartadas",
    noLeads: "No hay solicitudes.",
    leadEmail: "Correo",
    markContacted: "Marcar contactada",
    markConverted: "Marcar convertida",
    markDiscarded: "Descartar",
    adminEventsTitle: "Monitor de eventos",
    eventsLearners: "Aprendices",
    eventsSearch: "Buscar por nombre, usuario o correo",
    eventsNoLearners: "Aún no hay eventos registrados.",
    eventsPickLearner: "Selecciona un aprendiz para ver sus eventos.",
    eventsNone: "Este aprendiz no tiene eventos.",
    eventsFilterName: "Todos los eventos",
    eventsLastEvent: "Último evento",
    eventsWhen: "Fecha",
    eventsName: "Evento",
    eventsPlatform: "Plataforma",
    eventsDetail: "Detalle",
    eventsLoadMore: "Cargar más",
    eventsRefresh: "Actualizar",
    eventsNoName: "Sin nombre",
    actTitle: "Actividad de",
    actView: "Ver actividad",
    actPeriod: "Últimos 90 días",
    clsTitle: "Actividad de la clase",
    clsDesc: "Quién está practicando en la app y quién no. Toca un alumno para ver su detalle.",
    clsPeriod: "últimos 7 días",
    clsAllSections: "Todas las secciones",
    clsActiveWeek: "{n} de {total} practicaron esta semana",
    actNone: "Todavía no hay actividad. Aparecerá cuando el aprendiz use la versión más reciente de la app.",
    actLast: "Última actividad",
    actActiveDays: "Días activos",
    actTime: "Tiempo aprox. en la app",
    actStars: "Estrellas ganadas",
    actStarsTotal: "total",
    actMastered: "Elementos dominados",
    actModules: "Lo que más practicó",
    actHighlights: "Novedades",
    actFamilyAdded: "Agregó a {name} a su familia",
    actWordAdded: "Agregó la palabra «{word}»",
    actByDay: "Día a día",
    actMod_alphabet: "Alfabeto",
    actMod_sounds: "Sonidos",
    actMod_write: "Escribir",
    actMod_words: "Palabras",
    actMod_complete: "Completar",
    actMod_family: "Familia",
    actMod_colors: "Colores",
    actMod_math: "Números",
    actMod_shapes: "Figuras",
    actMod_read: "Lectura",
    actMod_other: "Otras actividades",
    newSchool: "Nueva escuela",
    schoolName: "Nombre de la escuela",
    adminEmailLabel: "Correo de la cuenta Escuela",
    adminPasswordLabel: "Contraseña",
    generate: "Generar",
    countryLabel: "País",
    institutionalPlan: "Suscripción institucional (opcional)",
    priceAmount: "Monto",
    currency: "Moneda",
    interval: "Periodo",
    validUntil: "Vigente hasta",
    createSchool: "Crear escuela",
    schoolCreated: "Escuela creada. Credenciales enviadas por correo.",
    existingSchools: "Escuelas registradas",
    noSchools: "Aún no hay escuelas.",
    manageSchool: "Gestionar",
    suspend: "Suspender",
    reactivate: "Reactivar",
    renew: "Renovar",
    resetPassword: "Resetear contraseña",
    students: "Alumnos",
    subscriptionLabel: "Suscripción",
    suspendConfirm: "¿Suspender esta escuela? Se revoca la IA para todos sus usuarios.",
    newPasswordGenerated: "Nueva contraseña",
    close: "Cerrar",
    schoolSuspended: "Escuela suspendida.",
    schoolReactivated: "Escuela reactivada.",
    schoolRenewed: "Suscripción renovada.",
    schoolPanelTitle: "Mi Escuela",
    teacherPanelTitle: "Mis Secciones",
    teachers: "Profesores",
    teacherName: "Nombre del profesor",
    addTeacher: "Agregar profesor",
    noTeachers: "Aún no hay profesores.",
    teacherCreated: "Profesor creado.",
    docType: "Tipo",
    docNumber: "Cédula / Documento",
    optional: "opcional",
    importTeachers: "Importar",
    importHelp: "Pega una persona por línea: nombre, cédula y correo (separados por coma o tabulación). El correo y la cédula se detectan solos.",
    importAutoEmail: "Generar correos automáticamente desde la cédula",
    importAutoEmailHint: "solo para quienes no tengan correo",
    importPreview: "Vista previa",
    importValid: "válidos",
    importNoName: "Falta el nombre",
    importNoEmail: "Falta el correo",
    importCreated: "Creados",
    importSkipped: "Omitidos",
    importFailed: "Con error",
    copyCredentials: "Copiar credenciales",
    copied: "Copiado",
    pageWord: "Página",
    teachersDesc: "Docentes de la escuela con acceso a la plataforma.",
    gradesDesc: "Los niveles de tu escuela. Cada alumno pertenece a un grado.",
    sectionsDesc: "Cada sección reúne un grado con sus profesores y alumnos.",
    studentsDesc: "Estudiantes de la escuela. Pertenecen a un grado y se enrolan en una sección.",
    teachersEmptyHint: "Agrega tu primer profesor arriba o impórtalos en lote.",
    gradesEmptyHint: "Crea los grados de tu escuela (ej. 1er Grado, 2do Grado).",
    sectionsEmptyHint: "Crea una sección y asígnale un grado y sus profesores.",
    studentsEmptyHint: "Agrega tu primer alumno o impórtalos en lote.",
    actionsCol: "Acciones",
    noGradesYet: "Primero crea un grado",
    sectionsNeedGrade: "Las secciones necesitan al menos un grado. Ve a Grados y crea uno.",
    studentsNeedGrade: "Cada alumno debe pertenecer a un grado. Ve a Grados y crea uno primero.",
    selectGrade: "Selecciona un grado",
    noSection: "Sin sección",
    section: "Sección",
    enrollStudents: "Enrolar alumnos",
    pickGradeFirst: "Elige un grado para ver sus alumnos.",
    noStudentsInGrade: "No hay alumnos en este grado todavía.",
    importStudents: "Importar alumnos",
    editStudent: "Editar alumno",
    deleteStudentConfirm: "¿Eliminar este alumno?",
    viewDetails: "Ver detalle",
    teacherDetail: "Detalle del profesor",
    studentDetail: "Detalle del alumno",
    editTeacher: "Editar profesor",
    noSectionsAssigned: "Sin secciones asignadas.",
    studentLoginNote: "Estas credenciales sirven para iniciar sesión en la app móvil MiABC.",
    // ── Representantes (acudientes de solo lectura) ──
    representatives: "Representantes",
    representativesDesc: "Acudientes que siguen el progreso de sus alumnos. Acceso web de solo lectura.",
    representativeName: "Nombre del representante",
    representativeEmail: "Correo del representante",
    addRepresentative: "Agregar representante",
    representativeCreated: "Representante creado.",
    noRepresentatives: "Aún no hay representantes.",
    representativesEmptyHint: "Crea un representante y asígnale uno o varios alumnos.",
    representativesNeedStudents: "Primero registra alumnos en la escuela para poder asignarlos.",
    editRepresentative: "Editar representante",
    deleteRepresentativeConfirm: "¿Eliminar este representante?",
    representativeDetail: "Detalle del representante",
    assignStudents: "Asignar alumnos",
    assignedStudents: "Alumnos asignados",
    noStudentsAssigned: "Sin alumnos asignados.",
    searchStudent: "Buscar alumno…",
    noStudentsYet: "Aún no hay alumnos",
    myStudents: "Mis Alumnos",
    representativePanelDesc: "Sigue el progreso de tus alumnos: último acceso, conexiones y palabras.",
    repEyebrow: "Representante",
    noStudentsRep: "Aún no tienes alumnos asignados. Pídele a la escuela que te asigne.",
    noTeachersAssigned: "Sin profesores asignados.",
    noStudentsInSection: "Sin alumnos enrolados todavía.",
    resetPasswordConfirm: "¿Restablecer la contraseña?",
    resetPasswordConfirmText: "Se generará una contraseña nueva y la actual dejará de funcionar.",
    students: "Alumnos",
    studentName: "Nombre del alumno",
    studentEmail: "Correo del alumno",
    teacherEmail: "Correo del profesor",
    addStudent: "Agregar alumno",
    noStudents: "Aún no hay alumnos.",
    studentCreated: "Alumno creado.",
    edit: "Editar",
    delete: "Eliminar",
    save: "Guardar",
    resetPassword: "Resetear contraseña",
    editSection: "Editar sección",
    deleteTeacherConfirm: "¿Eliminar este profesor?",
    deleteSectionConfirm: "¿Eliminar esta sección?",
    sectionHasStudents: "La sección tiene alumnos. Muévelos o elimínalos primero.",
    grades: "Grados",
    gradeName: "Nombre del grado",
    addGrade: "Agregar",
    noGrades: "Aún no hay grados.",
    editGrade: "Editar grado",
    deleteGradeConfirm: "¿Eliminar este grado?",
    gradeHasSections: "El grado tiene secciones. Elimínalas o muévelas primero.",
    viewStudents: "Ver alumnos",
    sections: "Secciones",
    sectionName: "Nombre de la sección",
    grade: "Grado",
    assignTeachers: "Asignar profesores",
    addSection: "Agregar sección",
    noSections: "Aún no hay secciones.",
    noSectionsTeacher: "No tienes secciones asignadas aún.",
    teacherEyebrow: "Mi panel",
    teacherPanelDesc: "Tus secciones y el seguimiento de cada alumno: último acceso, conexiones y actividad.",
    colLastAccess: "Último acceso",
    colConnections: "Conexiones",
    colStatus: "Estado",
    wordsCol: "Palabras",
    viewWords: "Ver palabras del alumno",
    studentWordsTitle: "Palabras de",
    stActive: "Activo",
    stInactive: "Inactivo",
    stNever: "Sin ingresar",
    daysShort: "d",
    neverWord: "Nunca",
    summaryActive: "Activos",
    summaryConns: "Conexiones",
    teacherAuthorSoon: "Próximamente: genera palabras, textos e inferencia para toda la sección desde aquí.",
    teacherAuthorHint: "Genera un texto y se reparte a todos los alumnos de esta sección.",
    teacherAuthorTitle: "Crea contenido para tus alumnos",
    teacherAuthorBody: "Genera textos e inferencia igual que un padre. Luego, desde tu Lista de textos o Contenidos guardados, usa el botón Repartir para enviarlo a una sección completa.",
    distributeTooltip: "Repartir a una sección",
    distributeTitle: "Repartir a una sección",
    distributeText: "Se enviará a todos los alumnos de la sección que elijas.",
    distributeSelect: "Elige una sección",
    distributeConfirm: "Repartir",
    distributing: "Repartiendo…",
    distributeDoneTitle: "¡Repartido!",
    distributeDoneA: "Enviado a",
    distributeAppNote: "Lo verán al iniciar sesión en la app móvil.",
    distributeNoSectionsTitle: "Sin secciones",
    distributeNoSections: "Aún no tienes secciones asignadas para repartir contenido.",
    genForSection: "Generar texto para la sección",
    genModalHint: "Se genera UNA vez con IA y se reparte a cada alumno de la sección. Aparecerá en su app.",
    genBaseText: "Texto base (lectura)",
    genBasePlaceholder: "Pega o escribe el texto de lectura del que se generarán las preguntas…",
    genLevels: "Niveles de Bloom",
    genPerLevel: "Preguntas por nivel",
    genDifficulty: "Dificultad",
    genLanguage: "Idioma",
    genGenerate: "Generar y repartir",
    genGenerating: "Generando…",
    genDone: "¡Texto repartido!",
    genDistributedA: "Repartido a",
    genQuestions: "preguntas",
    genAppNote: "Los alumnos lo verán al iniciar sesión en la app móvil MiABC.",
    level_recordar: "Recordar",
    level_entender: "Entender",
    level_aplicar: "Aplicar",
    level_analizar: "Analizar",
    level_evaluar: "Evaluar",
    level_crear: "Crear",
    "diff_fácil": "Fácil",
    diff_medio: "Medio",
    "diff_difícil": "Difícil",
    genInfForSection: "Generar inferencia",
    infModalHint: "Genera una lección de inferencia (imagen + lectura + preguntas) UNA vez y se reparte a toda la sección.",
    infIdea: "Idea o tema de la lección",
    infIdeaPlaceholder: "Ej.: Los animales de la granja y sus sonidos…",
    infNumQ: "Preguntas",
    infNumImgQ: "Preguntas de imagen",
    infImgDiff: "Dificultad imagen",
    infGenerate: "Generar lección",
    infGenerating: "Generando (puede tardar)…",
    infPreview: "Vista previa de la lección",
    infImgQuestions: "de imagen",
    infVocab: "vocabulario",
    infReadyHint: "Revisa la lección. Al repartir, se guarda la imagen y llega a cada alumno.",
    infBack: "Volver",
    infDistribute: "Repartir a la sección",
    infDistributing: "Repartiendo…",
    studentsComingSoon: "Alumnos: próximamente",
    planMonthly: "Mensual",
    planAnnual: "Anual",
    perMonth: "/mes",
    perYear: "/año",
    bestValue: "Mejor valor",
    planMonthlyNote: "Facturado mensualmente. Cancela cuando quieras.",
    planAnnualNote: "Equivale a $3.33/mes — ahorras ~33%.",
    aiFeature1: "Generación de lecturas con imágenes (Inferencia)",
    aiFeature2: "Cuestionarios con Taxonomía de Bloom",
    aiFeature3: "Preguntas y respuestas asistidas por IA",
    aiFeature4: "Vocabulario y actividades automáticas",
    activateAi: "Activar IA",
    paywallTitle: "Esta función requiere IA activa",
    paywallText: "Para usar este módulo necesitas una suscripción de IA activa.",
    paywallButton: "Ver planes y activar IA",
    checkoutError: "No se pudo iniciar el pago.",
    sessionInvalid: "Sesión no válida. Vuelve a iniciar sesión.",

    // Navegación y general
    language: "Idioma",
    spanish: "Español",
    english: "Inglés",
    tamil: "Tamil",

    // File upload
    uploadFile: "Subir Archivo",
    or: "O",
    dragDropFile: "Arrastra y suelta un archivo aquí, o haz clic para seleccionar",
    supportedFormats: "Formatos soportados: PDF, DOCX",
    fileSizeLimit: "Tamaño máximo de archivo: 10MB",
    extractingText: "Extrayendo texto...",
    fileUploadError: "Error al subir archivo",
    invalidFileType: "Tipo de archivo inválido. Por favor sube solo archivos PDF o DOCX.",
    fileTooLarge: "El archivo es demasiado grande. El tamaño máximo es 10MB.",
    removeFile: "Eliminar archivo",
    uploadedFile: "Archivo subido",
    noFileSelected: "No se ha seleccionado ningún archivo",

    // Páginas principales
    login: "Iniciar Sesión",
    register: "Registrarse",
    forgotPassword: "Olvidé mi Contraseña",
    dashboard: "Panel de Control",

    welcome: "¡Bienvenido!",
    email: "Correo electrónico",
    password: "Contraseña",
    loginButton: "Entrar",
    forgotPassword: "Olvidaste tu contraseña?",
    noAccount: "No tienes una cuenta?",
    privacyText: "Al ingresar, aceptas nuestra",
    privacyPolicy: "Política de Privacidad",

    otpTabPassword: "Contraseña",
    otpTabCode: "Código por correo",
    otpSendCode: "Enviarme un código",
    otpSending: "Enviando…",
    otpSentTo: "Escribe el código de 6 dígitos que enviamos a",
    otpVerify: "Verificar y entrar",
    otpVerifying: "Verificando…",
    otpResend: "Reenviar código",
    otpResendIn: "Reenviar en",
    otpChangeEmail: "Usar otro correo",
    otpCheckSpam: "¿No lo ves? Revisa la carpeta de spam.",
    otpSentToast: "Si el correo tiene cuenta, te enviamos un código.",
    otpErrInvalidEmail: "Escribe un correo válido.",
    otpErrSend: "No pudimos enviar el código. Intenta de nuevo.",
    otpErrWrong: "Código incorrecto. Verifícalo e intenta de nuevo.",
    otpErrExpired: "El código venció. Pide uno nuevo.",
    otpErrTooMany: "Demasiados intentos. Pide un código nuevo.",
    otpErrNoCode: "Pide un código primero.",

    learnerNotRegistered:
      "El aprendíz no ha sido registrado en la app móvil aún, debe completar su registro para acceder a esta plataforma.",
    noAccess: "Este usuario no tiene acceso a esta plataforma.",
    verifyData: "Verifique sus datos",

    createAccount: "¡Crea una cuenta!",
    selectRolePlaceholder: "Selecciona tu rol",
    errInvalidCode: "El código es inválido, por favor verifique y vuelva a intentar",
    errCodeInUse: "Este código ya está en uso, por favor verifique y vuelva a intentar",
    errEmailInUse: "Este correo ya está en uso",
    errUserNotFound: "Este usuario no se encuentra registrado",
    errInvalidEmail: "Correo inválido",
    errTooManyRequests: "Por favor intente de nuevo en unos minutos",
    errMissingEmail: "El campo correo no puede estar vacío",
    errUnexpected: "Ocurrió un error inesperado",
    errAvatarRequired: "Debe subir una imagen de perfil, regrese al paso 2",
    errRoleRequired: "Debe seleccionar un rol, regrese al paso 1",
    errAvatarUpload: "No se pudo subir la imagen de perfil, intenta de nuevo",
    errCheckConnection: "Chequee su conexión",
    errorTitle: "Error",
    contentFormatError: "El contenido generado tiene un formato incorrecto.",
    parent: "Padre",
    teacher: "Maestro",
    roleRequired: "El rol es requerido",
    next: "Siguiente",
    back: "atras",
    alreadyHaveAccount: "Ya tienes una cuenta?",
    signIn: "Inicia Sesión.",
    privacyRegisterText: "Al registrarte, aceptas nuestra",

    profileImageRequired: "La imagen de perfil es requerida",
    accessCode: "Código de acceso",
    accessCodeRequired: "El código de acceso es requerido",
    nameEmail: "Nombre / Correo",
    emailRequired: "El correo electrónico es requerido",
    passwordRequired: "La contraseña es requerida",

    emailInUse: "Correo electronico ya en uso.",
    invalidEmail: "Correo invalido.",
    weakPassword: "Contraseña es débil.",
    tooManyRequests: "Trate de nuevo en un minuto.",
    checkConnection: "Chequee su conexion.",

    generalInfo: "Información general de",
    username: "Nombre de usuario",
    grade: "Grado",
    apprenticeName: "Nombre del aprendíz",
    congratulatoryPhrase: "Frase de felicitación",
    lastLogin: "Último inicio de sesión",
    updateNote: "Se actualizará únicamente al cerrar sesión en la app móvil",

    // Formularios de login
    confirmPassword: "Confirmar Contraseña",
    registerButton: "Registrarse",
    forgotPasswordButton: "Recuperar Contraseña",
    emailSentSuccess: "Correo enviado con éxito",
    checkInbox: "Revisa tu bandeja de entrada y sigue las instrucciones",
    restartPassword: "Recuperar Contraseña",
    sendInstructions: "Enviar Instrucciones",

    // Navegación del dashboard
    wordsCreated: "Palabras Creadas",
    wordsReceived: "Palabras Recibidas",
    wordsSent: "Palabras Enviadas",
    familyCreated: "Familia Creada",
    createText: "Crear Texto",
    listTexts: "Lista de Textos",
    downloads: "Descargas",

    // Mensajes comunes
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    search: "Buscar",
    deleteConfirmation: "¿Confirmar eliminación?",
    cannotRevertAction: "Esta acción no se puede revertir",
    yesDelete: "SÍ, ELIMINAR",
    deletedSuccessfully: "Eliminado exitosamente",

    // Términos y privacidad
    privacy: "Privacidad",
    terms: "Términos y Condiciones",

    // Aplicación educativa
    appTitle: "Mi ABC Online | Aplicación educativa",
    educationalApp: "Aplicación Educativa",

    // Mensajes de error y éxito
    error: "Error",
    success: "Éxito",
    invalidCredentials: "Credenciales inválidas",
    passwordMismatch: "Las contraseñas no coinciden",

    // Palabras y listas
    words: "Palabras",
    texts: "Textos",
    family: "Familia",
    syllables: "Sílabas",
    topic: "Tema",
    sentTo: "Enviada a",
    sentBy: "Enviada por",
    details: "Detalles",
    actions: "Acciones",
    create: "Crear",
    previous: "Anterior",

    // Títulos de páginas
    wordsCreatedList: "Lista de palabras creadas",
    wordsReceivedList: "Lista de palabras recibidas",
    wordsSentList: "Lista de palabras enviadas",
    familyMembersList: "Lista de miembros agregados",
    readingTextsCreated: "Textos de lectura creados",
    numberOfQuestions: "Número de preguntas",

    // Mensajes
    noWordsReceived: "No hay palabras recibidas.",
    from: "de",

    // Descargas
    downloadsDocumentation: "Descargas de Documentación",
    downloadInfo: "Aquí puedes descargar algunos documentos de apoyo.",
    information: "Información",
    downloading: "Descargando...",
    downloaded: "Descargado",
    downloadPDF: "Descargar PDF",
    downloadCompleted: "¡Descarga Completada!",
    fileDownloadedSuccessfully: "se ha descargado correctamente.",
    accept: "Aceptar",
    downloadingFiles: "Descargando archivos",
    downloadAllStarted: "La descarga de todos los archivos ha comenzado",

    // Creación de textos
    createReadingText: "Crear texto para lecturas",
    editTextContent: "Editar contenido del texto",
    textContent: "Contenido del texto",
    numberOfQuestionsLabel: "Número de preguntas",
    questionType: "Tipo de pregunta",
    difficulty: "Dificultad",
    format: "Formato",
    generateQuestions: "Generar preguntas",
    generating: "Generando...",
    deleteSelected: "Eliminar seleccionadas",
    resetForm: "Resetear formulario",
    saveText: "Guardar texto",
    updateText: "Actualizar texto",

    // Opciones de formulario
    selectDifficulty: "Selecciona la dificultad",
    easy: "Fácil",
    medium: "Medio",
    hard: "Difícil",
    selectFormat: "Seleccione el formato",
    multipleChoice: "Selección Múltiple",
    trueFalse: "Verdadero o Falso",
    openFormat: "Formato abierto",
    selectLanguage: "Seleccione el idioma",
    open: "Abierto",
    bloomsTaxonomy: "Taxonomía de Bloom",
    formatHelp: "Seleccione el formato del questionario, puede ser abierto o basado en la Taxonomía de Bloom.",
    moduleInfo: "En este módulo podrás generar un conjunto de preguntas y sus respuestas, a partir de un texto.",
    introduceText: "Introduzca el texto",
    textHelp: "Introduzca un texto a partir del cual se generarán las preguntas.",
    selectQuestionType: "Seleccione el tipo de pregunta",
    trueFalse: "Verdadero o Falso",
    openAnswer: "Respuesta Abierta",
    selectDifficulty: "Seleccione el nivel de dificultad de pregunta",
    difficult: "Difícil",
    limitQuestions: "Limitar cantidad de preguntas a:",
    limitHelp: "Introduzca el número máximo de preguntas que desea generar, 0 generará el máximo posible.",
    selectLanguage: "Seleccione el idioma",
    spanish: "Español",
    english: "Inglés",
    languageHelp: "Seleccione el idioma en el que quiere los resultados.",
    regenerate: "Volver a generar",
    results: "Resultados:",
    clickQuestions:
      "Haga clic en las preguntas para desplegar el detalle. Haga clic en las casillas si desea eliminar alguna pregunta.",
    removeSelected: "Remover seleccionados",
    options: "Opciones:",
    answer: "Respuesta:",
    true: "Verdadero",
    false: "Falso",
    noQuestionsGenerated: "No se han generado preguntas y respuestas aún.",
    generatePDF: "Generar e Imprimir PDF",
    generatePDFWithAnswers: "Generar e Imprimir PDF (con respuestas)",
    generatePDFNoAnswers: "Generar e Imprimir PDF (sin respuestas)",
    update: "Actualizar",
    reset: "Restablecer",
    clear: "Borrar",
    bloomsModuleInfo:
      "En este módulo podrás generar un conjunto de preguntas y sus respuestas, a partir de un texto y basado en la Taxonomía de Bloom.",
    selectLevels: "Seleccione los niveles",
    create: "Crear",
    evaluate: "Evaluar",
    analyze: "Analizar",
    apply: "Aplicar",
    understand: "Entender",
    remember: "Recordar",
    levelsHelp:
      "Seleccione los niveles de la Taxonomía de Bloom que desea que sean generados en las preguntas, no seleccionar ningún nivel generará preguntas para todos.",
    limitBloomsHelp: "Introduzca el número máximo de preguntas que desea generar por nivel, máximo 8.",
    inferenceLearning: "Aprendizaje por Inferencia",
    inferenceIdeaLabel: "Idea o concepto para la imagen",
    inferenceIdeaPlaceholder: "Ej: Un bosque mágico con animales que hablan...",
    numQuestionsPerLevelLabel: "Preguntas por cada nivel Bloom",
    questionsPerLevelHelp: "Se generarán estas preguntas por cada nivel de Bloom seleccionado.",
    questionsTotalWord: "preguntas en total",
    inferenceReadingText: "Texto para Lectura",
    inferenceQuestions: "Preguntas de Inferencia",
    generateInference: "Generar Inferencia",
    vocabularyList: "Vocabulario",
    discard: "Descartar",
    save: "Guardar",
    saving: "Guardando...",

    // CreateTextContainer messages
    unexpectedError: "Ocurrió un error inesperado.",
    updatedSuccessfully: "Actualizado correctamente.",
    savedSuccessfully: "Guardado correctamente.",
    completeFieldsAndGenerate: "Complete ambos campos y genere las preguntas para continuar.",
    editTextContent: "Editar contenido del texto",
    createTextForReading: "Crear texto para lecturas",
    selectDifficultyFirst: "Por favor seleccione el nivel de dificultad de las preguntas.",
    introduceTextFirst: "Por favor introdúzca el texto antes de generar las preguntas.",
    selectLanguageFirst: "Por favor introdúzca el idioma antes de generar las preguntas.",
    selectQuestionTypeFirst: "Seleccione el tipo de pregunta antes de generar.",
    introduceLimitFirst: "Por favor introdúzca el límite de preguntas antes de generarlas.",
    questionsLimitExceeded: "Límite de preguntas sobrepasado.",

    // Terms/Privacy Policy page
    privacyPolicy: "Política de Privacidad",
    introduction: "Introducción",
    welcomeText:
      "¡Bienvenido a MiABC! Estamos dedicados a proporcionar una experiencia de aprendizaje segura y agradable para los niños. Proteger la privacidad de su hijo es una prioridad para nosotros. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos la información personal de los niños menores de 13 años que usan nuestra aplicación. Al usar MiABC, usted acepta los términos descritos en esta política.",
    informationWeCollect: "Información que Recopilamos",
    personalInformation: "Información Personal",
    personalInfoText:
      "No recopilamos información personal directamente de los niños sin el consentimiento de los padres. La información personal puede incluir:",
    contactInfo:
      "Información de Contacto del Padre/Tutor: Dirección de correo electrónico o número de teléfono proporcionados durante el registro de la cuenta para habilitar la comunicación y verificación del consentimiento.",
    childInfo:
      "Información del Niño: Nombre y edad, proporcionados por los padres o tutores durante la configuración de la cuenta para personalizar la experiencia de aprendizaje.",
    nonPersonalInformation: "Información No Personal",
    nonPersonalInfoText:
      "Podemos recopilar información no personal para mejorar la funcionalidad y la experiencia del usuario en la aplicación. Esto incluye:",
    deviceInfo:
      "Información del Dispositivo: Tipo de dispositivo, sistema operativo e identificadores únicos del dispositivo.",
    usageData:
      "Datos de Uso: Información sobre cómo se utiliza la aplicación, incluyendo las funciones accesadas, el tiempo pasado en la aplicación y el progreso del aprendizaje.",
    howWeUseInfo: "Cómo Usamos la Información",
    personalInfoUsage: "La información personal se utiliza únicamente para los siguientes propósitos:",
    accountManagement:
      "Gestión de Cuentas: Crear y gestionar cuentas de usuario, verificar el consentimiento de los padres y proporcionar soporte al cliente.",
    personalization: "Personalización: Adaptar la experiencia de aprendizaje según la edad y preferencias del niño.",
    communication: "Comunicación: Enviar actualizaciones importantes y notificaciones a los padres o tutores.",
    nonPersonalInfoUsage:
      "La información no personal nos ayuda a mejorar la aplicación y asegurar una mejor experiencia de usuario mediante:",
    usageAnalysis:
      "Análisis de Tendencias de Uso: Comprender cómo los usuarios interactúan con la aplicación para mejorar las funciones y la funcionalidad.",
    technicalSupport: "Soporte Técnico: Identificar y solucionar problemas técnicos.",
    researchDevelopment:
      "Investigación y Desarrollo: Desarrollar nuevas características y contenido educativo basado en el comportamiento y las opiniones de los usuarios.",
    dataSecurity: "Seguridad de los Datos",
    dataSecurityText:
      "Estamos comprometidos a proteger la información de su hijo. Implementamos medidas de seguridad estándar en la industria para proteger la información personal contra el acceso no autorizado, la alteración, la divulgación o la destrucción. Estas medidas incluyen cifrado, servidores seguros y evaluaciones de seguridad regulares. Sin embargo, tenga en cuenta que ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro.",
    parentalConsent: "Consentimiento Parental",
    parentalConsentText:
      "Requerimos el consentimiento parental verificable antes de recopilar, usar o divulgar información personal de niños menores de 13 años. Los padres o tutores pueden proporcionar su consentimiento a través de varios métodos, incluyendo:",
    emailConsent:
      "Consentimiento por Correo Electrónico: Envío de un formulario de consentimiento firmado por correo electrónico.",
    paymentConsent:
      "Consentimiento por Pago: Uso de una transacción con tarjeta de crédito para verificar la identidad y el consentimiento.",
    consentForm: "Formulario de Consentimiento: Completar un formulario de consentimiento en línea.",
    parentRights:
      "Los padres tienen el derecho de revisar, corregir o eliminar la información personal de su hijo en cualquier momento contactándonos en miabc.app@gmail.com.",
    informationSharing: "Compartición de Información",
    informationSharingText:
      "No compartimos información personal con terceros, excepto en las siguientes circunstancias:",
    serviceProviders:
      "Proveedores de Servicios: Proveedores de servicios de terceros confiables que nos ayudan a operar la aplicación, siempre que cumplan con nuestras políticas de protección de datos.",
    legalRequirements:
      "Requisitos Legales: Cuando lo requiera la ley o para proteger la seguridad y los derechos de nuestros usuarios.",
    thirdPartyLinks: "Enlaces a Terceros",
    thirdPartyLinksText:
      "MiABC puede contener enlaces a sitios web o servicios de terceros. Estos no están regidos por esta Política de Privacidad. Animamos a los padres a revisar las políticas de privacidad de estos terceros antes de permitir que sus hijos los accedan.",
    policyChanges: "Cambios a Esta Política de Privacidad",
    policyChangesText:
      "Podemos actualizar esta Política de Privacidad de vez en cuando. Los padres serán notificados de cualquier cambio significativo por correo electrónico o a través de un aviso dentro de la aplicación. El uso continuado de la aplicación después de dichos cambios constituirá el reconocimiento y la aceptación de la política actualizada.",
    contactUs: "Contáctenos",
    contactUsText: "Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad, por favor contáctenos en:",
    email: "Email",
    thankYou:
      "Gracias por confiar en MiABC con el aprendizaje de su hijo. Estamos comprometidos a asegurar una experiencia segura y enriquecedora para todos los usuarios.",

    // Menu component
    dashboard: "Dashboard",
    words: "Palabras",
    added: "Agregadas",
    received: "Recibidas",
    sent: "Enviadas",
    family: "Familia",
    addedMembers: "Miembros Agregados",
    actions: "Acciones",
    createText: "Crear texto",
    textList: "Lista de textos",
    downloads: "Descargas",
    manageDownloads: "Gestiona y descarga tu documentación de apoyo",
    totalConnections: "Conexiones totales",
    personalAudio: "Audio Personal",
    personalAudioDescription: "Tu voz y frases de motivación personalizadas",
    welcomeBack: "Bienvenido de nuevo",
    representative: "Representante",
    monitoringLearner: "Estás siguiendo el progreso de",
    learnerBadge: "Aprendiz",
    learnerProfileHint: "Este es el perfil del aprendiz que acompañas.",
    manageSentWords: "Administra y visualiza las palabras que has enviado",
    noWords: "No hay palabras disponibles",
    manageTexts: "Administra y visualiza tus textos de lectura",
    questions: "preguntas",
    questionSingular: "pregunta",
    perLevel: "/ nivel",
    mixed: "Mixto",
    close: "Cerrar",
    lessonNotFound: "Lección no encontrada",
    noSavedLessons: "Aún no tienes lecciones guardadas.",
    errorDeleting: "Error al eliminar",
    savingImage: "Guardando y almacenando imagen...",
    noTextsYet: "No hay textos generados todavía.",
    downloadCompleteTitle: "¡Descarga Completada!",
    downloadCompleteText: "El archivo se ha descargado correctamente.",
    downloadingTitle: "Descargando archivos",
    downloadingText: "La descarga de todos los archivos ha comenzado",
    accept: "Aceptar",
    view: "Ver",
    sessionStarted: "Sesión iniciada como:",
    userManual: "Manual de MiABC",
    userGuide: "Guía de usuario",
    userGuideSubtitle: "Manual interactivo de MiABC Online",
    logout: "Cerrar sesión",
    
    // Inference Learning
    inferenceLearning: "Aprendizaje por Inferencia",
    inferenceIdeaPlaceholder: "Escribe una idea (ej: Un astronauta en la luna)",
    generateInference: "Generar Contenido",
    pedagogicalObjective: "Objetivo Pedagógico",
    vocabularyList: "Vocabulario",
    inferenceQuestions: "Preguntas de Inferencia",
    generatingContent: "Generando contenido (DALL-E & Gemini)...",
    numQuestionsLabel: "Cantidad de preguntas (1-5):",
    errorGenerating: "Ocurrió un error al generar el contenido de inferencia.",
    inferenceReadingText: "Texto de Lectura",
    discard: "Descartar",
    savedSuccessfully: "Contenido guardado exitosamente",
    errorSaving: "Error al intentar guardar",
    inferenceIdeaLabel: "¿Sobre qué quieres crear la lección?",
    savedLessonsTitle: "Contenidos Guardados",
    deleteConfirmationTitle: "¿Estás seguro?",
    deleteConfirmationText: "Esta acción no se puede deshacer.",
    delete: "Eliminar",
    deletedSuccessfully: "Lección eliminada",
    cancel: "Cancelar",
    imageQuestionsTitle: "Preguntas sobre la Imagen",
    easy: "Fácil",
    medium: "Medio",
    hard: "Difícil",
    textQuestionsSettings: "Preguntas de Lectura y Comprensión (Taxonomía de Bloom)",
    bloomDifficultyHelp: "Define qué tan complejo será el texto y su vocabulario.",
    visualQuestionsSettings: "Preguntas de Observación Visual",
    visualDifficultyHelp: "Qué tan profunda debe ser la observación del estudiante.",
    visualQuestionsHelp: "Preguntas basadas únicamente en la imagen generada.",
  },

  en: {
    // AI Subscription
    aiSubscription: "AI Subscription",
    aiActivateTitle: "Activate Artificial Intelligence",
    aiActivateSubtitle: "Unlock miabc's AI modules to automatically create readings, quizzes and activities.",
    aiActiveTitle: "Your AI subscription is active 🎉",
    aiActiveSubtitle: "You can now use all AI modules.",
    aiValidUntil: "Valid until",
    manageSubscription: "Manage subscription",
    manageLocalNote: "Subscription via local payment. For changes or renewal, contact us.",
    onboardingTitle: "Welcome to miabconline!",
    onboardingSubtitle: "You haven't registered your learner yet. Follow these steps to get started.",
    onboardingCodeLabel: "Your access code",
    onboardingStep1: "Download the MIABC app on your phone or tablet.",
    onboardingStep2: "Create your learner's profile using the access code above.",
    onboardingStep3: "Come back here and tap “I've registered my learner” to see their progress.",
    onboardingDownloadApp: "Google Play",
    onboardingEnter: "I've registered my learner",
    onboardingHelp: "Need help? Reach out and we'll gladly guide you.",
    portalError: "Could not open the management portal.",
    payWithLocal: "In Venezuela? Pay with Pago Móvil / Transfer",
    choosePaymentMethod: "Choose how to pay",
    payCardTitle: "Card",
    payCardDesc: "International card payment. Activates instantly.",
    payCardBadge: "Instant",
    payLocalTitle: "Pago Móvil or transfer",
    payLocalDesc: "From your bank in Venezuela. Activates once we verify your receipt.",
    payLocalBadge: "Venezuela",
    localPaymentTitle: "Pago Móvil / Bank Transfer",
    localPaymentSubtitle: "Pay from Venezuela and we'll activate your subscription once we verify the receipt.",
    payToAccount: "Pay to this account",
    referencePrice: "Reference price",
    selectPlan: "Select the plan",
    paymentReference: "Reference number",
    originBank: "Origin bank",
    amountPaid: "Amount paid",
    paymentDate: "Payment date",
    uploadProof: "Upload the receipt",
    proofHint: "Image of the payment (screenshot or photo).",
    submitPayment: "Submit receipt",
    proofRequired: "You must upload the receipt.",
    proofUploadError: "Could not upload the receipt. Please try again.",
    paymentUnderReviewTitle: "Payment under review",
    paymentUnderReviewText: "We received your receipt. We'll activate your subscription once verified (usually within a few hours).",
    adminPaymentsTitle: "Payments to reconcile",
    statusPending: "Pending",
    statusConfirmed: "Confirmed",
    statusRejected: "Rejected",
    notAuthorized: "Not authorized.",
    noPayments: "No payments to show.",
    viewProof: "View receipt",
    confirmPayment: "Confirm",
    rejectPayment: "Reject",
    rejectReasonPrompt: "Rejection reason (optional)",
    paymentConfirmed: "Payment confirmed and subscription activated.",
    paymentRejected: "Payment rejected.",
    adminSchoolsTitle: "Schools",
    adminLeadsTitle: "School requests",
    leadNew: "New",
    leadContacted: "Contacted",
    leadConverted: "Converted",
    leadDiscarded: "Discarded",
    noLeads: "No requests.",
    leadEmail: "Email",
    markContacted: "Mark contacted",
    markConverted: "Mark converted",
    markDiscarded: "Discard",
    adminEventsTitle: "Events monitor",
    eventsLearners: "Learners",
    eventsSearch: "Search by name, username or email",
    eventsNoLearners: "No events recorded yet.",
    eventsPickLearner: "Select a learner to see their events.",
    eventsNone: "This learner has no events.",
    eventsFilterName: "All events",
    eventsLastEvent: "Last event",
    eventsWhen: "Date",
    eventsName: "Event",
    eventsPlatform: "Platform",
    eventsDetail: "Details",
    eventsLoadMore: "Load more",
    eventsRefresh: "Refresh",
    eventsNoName: "No name",
    actTitle: "Activity of",
    actView: "View activity",
    actPeriod: "Last 90 days",
    clsTitle: "Class activity",
    clsDesc: "Who is practicing in the app and who is not. Tap a student to see the details.",
    clsPeriod: "last 7 days",
    clsAllSections: "All sections",
    clsActiveWeek: "{n} of {total} practiced this week",
    actNone: "No activity yet. It will appear once the learner uses the latest version of the app.",
    actLast: "Last activity",
    actActiveDays: "Active days",
    actTime: "Approx. time in the app",
    actStars: "Stars earned",
    actStarsTotal: "total",
    actMastered: "Items mastered",
    actModules: "What they practiced most",
    actHighlights: "Highlights",
    actFamilyAdded: "Added {name} to their family",
    actWordAdded: "Added the word “{word}”",
    actByDay: "Day by day",
    actMod_alphabet: "Alphabet",
    actMod_sounds: "Sounds",
    actMod_write: "Writing",
    actMod_words: "Words",
    actMod_complete: "Complete",
    actMod_family: "Family",
    actMod_colors: "Colors",
    actMod_math: "Numbers",
    actMod_shapes: "Shapes",
    actMod_read: "Reading",
    actMod_other: "Other activities",
    newSchool: "New school",
    schoolName: "School name",
    adminEmailLabel: "School account email",
    adminPasswordLabel: "Password",
    generate: "Generate",
    countryLabel: "Country",
    institutionalPlan: "Institutional subscription (optional)",
    priceAmount: "Amount",
    currency: "Currency",
    interval: "Period",
    validUntil: "Valid until",
    createSchool: "Create school",
    schoolCreated: "School created. Credentials sent by email.",
    existingSchools: "Registered schools",
    noSchools: "No schools yet.",
    manageSchool: "Manage",
    suspend: "Suspend",
    reactivate: "Reactivate",
    renew: "Renew",
    resetPassword: "Reset password",
    students: "Students",
    subscriptionLabel: "Subscription",
    suspendConfirm: "Suspend this school? AI will be revoked for all its users.",
    newPasswordGenerated: "New password",
    close: "Close",
    schoolSuspended: "School suspended.",
    schoolReactivated: "School reactivated.",
    schoolRenewed: "Subscription renewed.",
    schoolPanelTitle: "My School",
    teacherPanelTitle: "My Sections",
    teachers: "Teachers",
    teacherName: "Teacher name",
    addTeacher: "Add teacher",
    noTeachers: "No teachers yet.",
    teacherCreated: "Teacher created.",
    docType: "Type",
    docNumber: "ID / Document",
    optional: "optional",
    importTeachers: "Import",
    importHelp: "Paste one person per line: name, ID and email (separated by comma or tab). Email and ID are detected automatically.",
    importAutoEmail: "Auto-generate emails from the ID number",
    importAutoEmailHint: "only for those without an email",
    importPreview: "Preview",
    importValid: "valid",
    importNoName: "Missing name",
    importNoEmail: "Missing email",
    importCreated: "Created",
    importSkipped: "Skipped",
    importFailed: "Failed",
    copyCredentials: "Copy credentials",
    copied: "Copied",
    pageWord: "Page",
    teachersDesc: "Your school's teachers with access to the platform.",
    gradesDesc: "Your school's levels. Every student belongs to a grade.",
    sectionsDesc: "Each section brings a grade together with its teachers and students.",
    studentsDesc: "Your school's students. They belong to a grade and enroll in a section.",
    teachersEmptyHint: "Add your first teacher above, or import them in bulk.",
    gradesEmptyHint: "Create your school's grades (e.g. Grade 1, Grade 2).",
    sectionsEmptyHint: "Create a section, then assign it a grade and its teachers.",
    studentsEmptyHint: "Add your first student, or import them in bulk.",
    actionsCol: "Actions",
    noGradesYet: "Create a grade first",
    sectionsNeedGrade: "Sections need at least one grade. Go to Grades and create one.",
    studentsNeedGrade: "Every student must belong to a grade. Go to Grades and create one first.",
    selectGrade: "Select a grade",
    noSection: "No section",
    section: "Section",
    enrollStudents: "Enroll students",
    pickGradeFirst: "Pick a grade to see its students.",
    noStudentsInGrade: "No students in this grade yet.",
    importStudents: "Import students",
    editStudent: "Edit student",
    deleteStudentConfirm: "Delete this student?",
    viewDetails: "View details",
    teacherDetail: "Teacher details",
    studentDetail: "Student details",
    editTeacher: "Edit teacher",
    noSectionsAssigned: "No sections assigned.",
    studentLoginNote: "These credentials are used to sign in to the MiABC mobile app.",
    // ── Representatives (read-only guardians) ──
    representatives: "Representatives",
    representativesDesc: "Guardians who follow their students' progress. Read-only web access.",
    representativeName: "Representative name",
    representativeEmail: "Representative email",
    addRepresentative: "Add representative",
    representativeCreated: "Representative created.",
    noRepresentatives: "No representatives yet.",
    representativesEmptyHint: "Create a representative and assign one or more students.",
    representativesNeedStudents: "First add students to the school so you can assign them.",
    editRepresentative: "Edit representative",
    deleteRepresentativeConfirm: "Delete this representative?",
    representativeDetail: "Representative details",
    assignStudents: "Assign students",
    assignedStudents: "Assigned students",
    noStudentsAssigned: "No students assigned.",
    searchStudent: "Search student…",
    noStudentsYet: "No students yet",
    myStudents: "My Students",
    representativePanelDesc: "Follow your students' progress: last access, connections and words.",
    repEyebrow: "Representative",
    noStudentsRep: "You have no students assigned yet. Ask the school to assign some.",
    noTeachersAssigned: "No teachers assigned.",
    noStudentsInSection: "No students enrolled yet.",
    resetPasswordConfirm: "Reset password?",
    resetPasswordConfirmText: "A new password will be generated and the current one will stop working.",
    students: "Students",
    studentName: "Student name",
    studentEmail: "Student email",
    teacherEmail: "Teacher email",
    addStudent: "Add student",
    noStudents: "No students yet.",
    studentCreated: "Student created.",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    resetPassword: "Reset password",
    editSection: "Edit section",
    deleteTeacherConfirm: "Delete this teacher?",
    deleteSectionConfirm: "Delete this section?",
    sectionHasStudents: "The section has students. Move or remove them first.",
    grades: "Grades",
    gradeName: "Grade name",
    addGrade: "Add",
    noGrades: "No grades yet.",
    editGrade: "Edit grade",
    deleteGradeConfirm: "Delete this grade?",
    gradeHasSections: "The grade has sections. Remove or move them first.",
    viewStudents: "View students",
    sections: "Sections",
    sectionName: "Section name",
    grade: "Grade",
    assignTeachers: "Assign teachers",
    addSection: "Add section",
    noSections: "No sections yet.",
    noSectionsTeacher: "You have no sections assigned yet.",
    teacherEyebrow: "My panel",
    teacherPanelDesc: "Your sections and each student's tracking: last access, connections and activity.",
    colLastAccess: "Last access",
    colConnections: "Connections",
    colStatus: "Status",
    wordsCol: "Words",
    viewWords: "View student's words",
    studentWordsTitle: "Words of",
    stActive: "Active",
    stInactive: "Inactive",
    stNever: "Not started",
    daysShort: "d",
    neverWord: "Never",
    summaryActive: "Active",
    summaryConns: "Connections",
    teacherAuthorSoon: "Coming soon: generate words, texts and inference for the whole section from here.",
    teacherAuthorHint: "Generate a text and it's shared with every student in this section.",
    teacherAuthorTitle: "Create content for your students",
    teacherAuthorBody: "Generate texts and inference just like a parent. Then, from your Text list or Saved contents, use the Share button to send it to a whole section.",
    distributeTooltip: "Share with a section",
    distributeTitle: "Share with a section",
    distributeText: "It will be sent to every student in the section you choose.",
    distributeSelect: "Choose a section",
    distributeConfirm: "Share",
    distributing: "Sharing…",
    distributeDoneTitle: "Shared!",
    distributeDoneA: "Sent to",
    distributeAppNote: "They'll see it when they sign in to the mobile app.",
    distributeNoSectionsTitle: "No sections",
    distributeNoSections: "You have no sections assigned yet to share content with.",
    genForSection: "Generate text for the section",
    genModalHint: "Generated ONCE with AI and shared with every student in the section. It appears in their app.",
    genBaseText: "Base text (reading)",
    genBasePlaceholder: "Paste or type the reading text the questions will be generated from…",
    genLevels: "Bloom levels",
    genPerLevel: "Questions per level",
    genDifficulty: "Difficulty",
    genLanguage: "Language",
    genGenerate: "Generate and share",
    genGenerating: "Generating…",
    genDone: "Text shared!",
    genDistributedA: "Shared with",
    genQuestions: "questions",
    genAppNote: "Students will see it when they sign in to the MiABC mobile app.",
    level_recordar: "Remember",
    level_entender: "Understand",
    level_aplicar: "Apply",
    level_analizar: "Analyze",
    level_evaluar: "Evaluate",
    level_crear: "Create",
    "diff_fácil": "Easy",
    diff_medio: "Medium",
    "diff_difícil": "Hard",
    genInfForSection: "Generate inference",
    infModalHint: "Generate an inference lesson (image + reading + questions) ONCE and share it with the whole section.",
    infIdea: "Lesson idea or topic",
    infIdeaPlaceholder: "E.g.: Farm animals and their sounds…",
    infNumQ: "Questions",
    infNumImgQ: "Image questions",
    infImgDiff: "Image difficulty",
    infGenerate: "Generate lesson",
    infGenerating: "Generating (may take a while)…",
    infPreview: "Lesson preview",
    infImgQuestions: "image",
    infVocab: "vocabulary",
    infReadyHint: "Review the lesson. On share, the image is saved and reaches every student.",
    infBack: "Back",
    infDistribute: "Share with the section",
    infDistributing: "Sharing…",
    studentsComingSoon: "Students: coming soon",
    planMonthly: "Monthly",
    planAnnual: "Annual",
    perMonth: "/mo",
    perYear: "/yr",
    bestValue: "Best value",
    planMonthlyNote: "Billed monthly. Cancel anytime.",
    planAnnualNote: "Equals $3.33/mo — save ~33%.",
    aiFeature1: "Reading generation with images (Inference)",
    aiFeature2: "Quizzes with Bloom's Taxonomy",
    aiFeature3: "AI-assisted questions and answers",
    aiFeature4: "Automatic vocabulary and activities",
    activateAi: "Activate AI",
    paywallTitle: "This feature requires active AI",
    paywallText: "To use this module you need an active AI subscription.",
    paywallButton: "View plans and activate AI",
    checkoutError: "Could not start payment.",
    sessionInvalid: "Invalid session. Please log in again.",

    // Navigation and general
    language: "Language",
    spanish: "Spanish",
    english: "English",
    tamil: "Tamil",

    // File upload
    uploadFile: "Upload File",
    or: "OR",
    dragDropFile: "Drag and drop a file here, or click to select",
    supportedFormats: "Supported formats: PDF, DOCX",
    fileSizeLimit: "Maximum file size: 10MB",
    extractingText: "Extracting text...",
    fileUploadError: "Error uploading file",
    invalidFileType: "Invalid file type. Please upload PDF or DOCX files only.",
    fileTooLarge: "File is too large. Maximum size is 10MB.",
    removeFile: "Remove file",
    uploadedFile: "Uploaded file",
    noFileSelected: "No file selected",

    // Main pages
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot Password",
    dashboard: "Dashboard",

    welcome: "Welcome!",
    email: "Email",
    password: "Password",
    loginButton: "Login",
    forgotPassword: "Forgot your password?",
    noAccount: "Don't have an account?",
    privacyText: "By logging in, you accept our",
    privacyPolicy: "Privacy Policy",

    otpTabPassword: "Password",
    otpTabCode: "Email code",
    otpSendCode: "Send me a code",
    otpSending: "Sending…",
    otpSentTo: "Enter the 6-digit code we sent to",
    otpVerify: "Verify and continue",
    otpVerifying: "Verifying…",
    otpResend: "Resend code",
    otpResendIn: "Resend in",
    otpChangeEmail: "Use another email",
    otpCheckSpam: "Can't find it? Check your spam folder.",
    otpSentToast: "If the email has an account, we sent a code.",
    otpErrInvalidEmail: "Enter a valid email.",
    otpErrSend: "We couldn't send the code. Try again.",
    otpErrWrong: "Wrong code. Check it and try again.",
    otpErrExpired: "The code expired. Request a new one.",
    otpErrTooMany: "Too many attempts. Request a new code.",
    otpErrNoCode: "Request a code first.",

    learnerNotRegistered:
      "The learner has not been registered in the mobile app yet, they must complete their registration to access this platform.",
    noAccess: "This user does not have access to this platform.",
    verifyData: "Please verify your data",

    createAccount: "Create an account!",
    selectRolePlaceholder: "Select your role",
    errInvalidCode: "The code is invalid, please check and try again",
    errCodeInUse: "This code is already in use, please check and try again",
    errEmailInUse: "This email is already in use",
    errUserNotFound: "This user is not registered",
    errInvalidEmail: "Invalid email",
    errTooManyRequests: "Please try again in a few minutes",
    errMissingEmail: "The email field cannot be empty",
    errUnexpected: "An unexpected error occurred",
    errAvatarRequired: "You must upload a profile picture, go back to step 2",
    errRoleRequired: "You must select a role, go back to step 1",
    errAvatarUpload: "Could not upload the profile picture, please try again",
    errCheckConnection: "Check your connection",
    errorTitle: "Error",
    contentFormatError: "The generated content has an incorrect format.",
    parent: "Parent",
    teacher: "Teacher",
    roleRequired: "Role is required",
    next: "Next",
    back: "Back",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign In.",
    privacyRegisterText: "By registering, you accept our",

    profileImageRequired: "Profile image is required",
    accessCode: "Access code",
    accessCodeRequired: "Access code is required",
    nameEmail: "Name / Email",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",

    emailInUse: "Email already in use.",
    invalidEmail: "Invalid email.",
    weakPassword: "Password is weak.",
    tooManyRequests: "Try again in a minute.",
    checkConnection: "Check your connection.",

    generalInfo: "General information for",
    username: "Username",
    grade: "Grade",
    apprenticeName: "Apprentice name",
    congratulatoryPhrase: "Congratulatory phrase",
    lastLogin: "Last login",
    updateNote: "Will only update when logging out of the mobile app",

    // Login forms
    confirmPassword: "Confirm Password",
    registerButton: "Register",
    forgotPasswordButton: "Recover Password",
    emailSentSuccess: "Email sent successfully",
    checkInbox: "Check your inbox and follow the instructions",
    restartPassword: "Reset Password",
    sendInstructions: "Send Instructions",

    // Dashboard navigation
    wordsCreated: "Words Created",
    wordsReceived: "Words Received",
    wordsSent: "Words Sent",
    familyCreated: "Family Created",
    createText: "Create Text",
    listTexts: "Text List",
    downloads: "Downloads",

    // Common messages
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    deleteConfirmation: "Confirm deletion?",
    cannotRevertAction: "This action cannot be reverted",
    yesDelete: "YES, DELETE",
    deletedSuccessfully: "Deleted successfully",

    // Terms and privacy
    privacy: "Privacy",
    terms: "Terms and Conditions",

    // Educational app
    appTitle: "My ABC Online | Educational Application",
    educationalApp: "Educational Application",

    // Error and success messages
    error: "Error",
    success: "Success",
    invalidCredentials: "Invalid credentials",
    passwordMismatch: "Passwords do not match",

    // Words and lists
    words: "Words",
    texts: "Texts",
    family: "Family",
    syllables: "Syllables",
    topic: "Topic",
    sentTo: "Sent to",
    sentBy: "Sent by",
    details: "Details",
    actions: "Actions",
    create: "Create",
    previous: "Previous",

    // Page titles
    wordsCreatedList: "Created words list",
    wordsReceivedList: "Received words list",
    wordsSentList: "Sent words list",
    familyMembersList: "Added members list",
    readingTextsCreated: "Created reading texts",
    numberOfQuestions: "Number of questions",

    // Messages
    noWordsReceived: "No words received.",
    from: "from",

    // Downloads
    downloadsDocumentation: "Documentation Downloads",
    downloadInfo: "Here you can download some support documents.",
    information: "Information",
    downloading: "Downloading...",
    downloaded: "Downloaded",
    downloadPDF: "Download PDF",
    downloadCompleted: "Download Completed!",
    fileDownloadedSuccessfully: "has been downloaded successfully.",
    accept: "Accept",
    downloadingFiles: "Downloading files",
    downloadAllStarted: "Download of all files has started",

    // Text creation
    createReadingText: "Create text for readings",
    editTextContent: "Edit text content",
    textContent: "Text content",
    numberOfQuestionsLabel: "Number of questions",
    questionType: "Question type",
    difficulty: "Difficulty",
    format: "Format",
    language: "Language",
    generateQuestions: "Generate questions and answers",
    generating: "Generating...",
    deleteSelected: "Delete selected",
    resetForm: "Reset form",
    saveText: "Save text",
    updateText: "Update text",

    // Form options
    selectDifficulty: "Select difficulty",
    easy: "Easy",
    medium: "Medium",
    difficult: "Difficult",
    selectFormat: "Select format",
    multipleChoice: "Multiple choice",
    trueFalse: "True/False",
    openFormat: "Open format",
    selectLanguage: "Select language",
    open: "Open",
    bloomsTaxonomy: "Bloom's Taxonomy",
    formatHelp: "Select the questionnaire format, it can be open or based on Bloom's Taxonomy.",
    moduleInfo: "In this module you can generate a set of questions and their answers, from a text.",
    introduceText: "Enter the text",
    textHelp: "Enter a text from which the questions will be generated.",
    selectQuestionType: "Select question type",
    trueFalse: "True or False",
    openAnswer: "Open Answer",
    selectDifficulty: "Select question difficulty level",
    limitQuestions: "Limit number of questions to:",
    limitHelp: "Enter the maximum number of questions you want to generate, 0 will generate the maximum possible.",
    selectLanguage: "Select language",
    spanish: "Spanish",
    english: "English",
    languageHelp: "Select the language in which you want the results.",
    regenerate: "Regenerate",
    results: "Results:",
    clickQuestions: "Click on questions to expand details. Click on checkboxes if you want to delete any question.",
    removeSelected: "Remove selected",
    options: "Options:",
    answer: "Answer:",
    true: "True",
    false: "False",
    noQuestionsGenerated: "No questions and answers have been generated yet.",
    generatePDF: "Generate and Print PDF",
    generatePDFWithAnswers: "Generate and Print PDF (with answers)",
    generatePDFNoAnswers: "Generate and Print PDF (without answers)",
    update: "Update",
    reset: "Reset",
    clear: "Clear",
    bloomsModuleInfo:
      "In this module you can generate a set of questions and their answers, from a text and based on Bloom's Taxonomy.",
    selectLevels: "Select levels",
    create: "Create",
    evaluate: "Evaluate",
    analyze: "Analyze",
    apply: "Apply",
    understand: "Understand",
    remember: "Remember",
    levelsHelp:
      "Select the levels for Bloom's Taxonomy that you want to be generated in the questions, not selecting any level will generate questions for all.",
    limitBloomsHelp: "Enter the maximum number of questions you want to generate per level, maximum 8.",
    inferenceLearning: "Inference Learning",
    inferenceIdeaLabel: "Idea or concept for the image",
    inferenceIdeaPlaceholder: "Ex: A magical forest with talking animals...",
    numQuestionsPerLevelLabel: "Questions per Bloom's level",
    questionsPerLevelHelp: "These questions will be generated for each selected Bloom's level.",
    questionsTotalWord: "questions in total",
    inferenceReadingText: "Reading Text",
    inferenceQuestions: "Inference Questions",
    generateInference: "Generate Inference",
    vocabularyList: "Vocabulary",
    discard: "Discard",
    save: "Save",
    saving: "Saving...",
    imageQuestionsTitle: "Questions about the Image",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",

    // CreateTextContainer messages
    unexpectedError: "An unexpected error occurred.",
    updatedSuccessfully: "Updated successfully.",
    savedSuccessfully: "Saved successfully.",
    completeFieldsAndGenerate: "Complete both fields and generate questions to continue.",
    editTextContent: "Edit text content",
    createTextForReading: "Create text for readings",
    selectDifficultyFirst: "Please select the difficulty level of the questions.",
    introduceTextFirst: "Please enter the text before generating questions.",
    selectLanguageFirst: "Please enter the language before generating questions.",
    selectQuestionTypeFirst: "Select the question type before generating.",
    introduceLimitFirst: "Please enter the question limit before generating them.",
    questionsLimitExceeded: "Question limit exceeded.",

    // Terms/Privacy Policy page
    privacyPolicy: "Privacy Policy",
    introduction: "Introduction",
    welcomeText:
      "Welcome to MiABC! We are dedicated to providing a safe and enjoyable learning experience for children. Protecting your child's privacy is a priority for us. This Privacy Policy explains how we collect, use, and protect the personal information of children under 13 who use our application. By using MiABC, you accept the terms described in this policy.",
    informationWeCollect: "Information We Collect",
    personalInformation: "Personal Information",
    personalInfoText:
      "We do not collect personal information directly from children without parental consent. Personal information may include:",
    contactInfo:
      "Parent/Guardian Contact Information: Email address or phone number provided during account registration to enable communication and consent verification.",
    childInfo:
      "Child Information: Name and age, provided by parents or guardians during account setup to personalize the learning experience.",
    nonPersonalInformation: "Non-Personal Information",
    nonPersonalInfoText:
      "We may collect non-personal information to improve the functionality and user experience of the application. This includes:",
    deviceInfo: "Device Information: Device type, operating system, and unique device identifiers.",
    usageData:
      "Usage Data: Information about how the application is used, including accessed features, time spent in the application, and learning progress.",
    howWeUseInfo: "How We Use Information",
    personalInfoUsage: "Personal information is used solely for the following purposes:",
    accountManagement:
      "Account Management: Create and manage user accounts, verify parental consent, and provide customer support.",
    personalization: "Personalization: Tailor the learning experience according to the child's age and preferences.",
    communication: "Communication: Send important updates and notifications to parents or guardians.",
    nonPersonalInfoUsage:
      "Non-personal information helps us improve the application and ensure a better user experience through:",
    usageAnalysis:
      "Usage Trend Analysis: Understanding how users interact with the application to improve features and functionality.",
    technicalSupport: "Technical Support: Identify and resolve technical issues.",
    researchDevelopment:
      "Research and Development: Develop new features and educational content based on user behavior and feedback.",
    dataSecurity: "Data Security",
    dataSecurityText:
      "We are committed to protecting your child's information. We implement industry-standard security measures to protect personal information against unauthorized access, alteration, disclosure, or destruction. These measures include encryption, secure servers, and regular security assessments. However, please note that no method of Internet transmission or electronic storage is 100% secure.",
    parentalConsent: "Parental Consent",
    parentalConsentText:
      "We require verifiable parental consent before collecting, using, or disclosing personal information from children under 13. Parents or guardians can provide their consent through various methods, including:",
    emailConsent: "Email Consent: Sending a signed consent form via email.",
    paymentConsent: "Payment Consent: Using a credit card transaction to verify identity and consent.",
    consentForm: "Consent Form: Completing an online consent form.",
    parentRights:
      "Parents have the right to review, correct, or delete their child's personal information at any time by contacting us at miabc.app@gmail.com.",
    informationSharing: "Information Sharing",
    informationSharingText:
      "We do not share personal information with third parties, except in the following circumstances:",
    serviceProviders:
      "Service Providers: Trusted third-party service providers who help us operate the application, provided they comply with our data protection policies.",
    legalRequirements: "Legal Requirements: When required by law or to protect the safety and rights of our users.",
    thirdPartyLinks: "Third Party Links",
    thirdPartyLinksText:
      "MiABC may contain links to third-party websites or services. These are not governed by this Privacy Policy. We encourage parents to review the privacy policies of these third parties before allowing their children to access them.",
    policyChanges: "Changes to This Privacy Policy",
    policyChangesText:
      "We may update this Privacy Policy from time to time. Parents will be notified of any significant changes via email or through a notice within the application. Continued use of the application after such changes will constitute acknowledgment and acceptance of the updated policy.",
    contactUs: "Contact Us",
    contactUsText: "If you have any questions or concerns about this Privacy Policy, please contact us at:",
    email: "Email",
    thankYou:
      "Thank you for trusting MiABC with your child's learning. We are committed to ensuring a safe and enriching experience for all users.",

    // Menu component
    dashboard: "Dashboard",
    words: "Words",
    added: "Added",
    received: "Received",
    sent: "Sent",
    family: "Family",
    addedMembers: "Added Members",
    actions: "Actions",
    createText: "Create text",
    textList: "Text list",
    downloads: "Downloads",
    manageDownloads: "Manage and download your support documentation",
    totalConnections: "Total Connections",
    personalAudio: "Personal Audio",
    personalAudioDescription: "Your voice and personalized motivational phrases",
    welcomeBack: "Welcome back",
    representative: "Parent / Guardian",
    monitoringLearner: "You're following the progress of",
    learnerBadge: "Learner",
    learnerProfileHint: "This is the profile of the learner you support.",
    manageSentWords: "Manage and view the words you have sent",
    noWords: "No words available",
    manageTexts: "Manage and view your reading texts",
    questions: "questions",
    questionSingular: "question",
    perLevel: "/ level",
    mixed: "Mixed",
    close: "Close",
    lessonNotFound: "Lesson not found",
    noSavedLessons: "You don't have any saved lessons yet.",
    errorDeleting: "Error deleting",
    savingImage: "Saving and storing image...",
    noTextsYet: "No texts generated yet.",
    downloadCompleteTitle: "Download Complete!",
    downloadCompleteText: "The file has been downloaded successfully.",
    downloadingTitle: "Downloading files",
    downloadingText: "The download of all files has started",
    accept: "OK",
    view: "View",
    sessionStarted: "Session started as:",
    userManual: "MiABC Manual",
    userGuide: "User Guide",
    userGuideSubtitle: "Interactive MiABC Online manual",
    logout: "Logout",
    
    // Inference Learning
    inferenceLearning: "Inference Learning",
    inferenceIdeaPlaceholder: "Write an idea (e.g. An astronaut on the moon)",
    generateInference: "Generate Content",
    pedagogicalObjective: "Pedagogical Objective",
    vocabularyList: "Vocabulary",
    inferenceQuestions: "Inference Questions",
    generatingContent: "Generating content (DALL-E & Gemini)...",
    numQuestionsLabel: "Number of questions (1-5):",
    errorGenerating: "An error occurred while generating the inference content.",
    inferenceReadingText: "Reading Text",
    discard: "Discard",
    savedSuccessfully: "Content saved successfully",
    errorSaving: "Error attempting to save",
    inferenceIdeaLabel: "What do you want to create the lesson about?",
    savedLessonsTitle: "Saved Contents",
    deleteConfirmationTitle: "Are you sure?",
    deleteConfirmationText: "This action cannot be undone.",
    delete: "Delete",
    deletedSuccessfully: "Lesson deleted",
    cancel: "Cancel",
    textQuestionsSettings: "Reading & Comprehension Questions (Bloom's Taxonomy)",
    bloomDifficultyHelp: "Defines the complexity of the text and its vocabulary.",
    visualQuestionsSettings: "Visual Observation Questions",
    visualDifficultyHelp: "How deep the student's observation should be.",
    visualQuestionsHelp: "Questions based solely on the generated image.",
  },

  ta: {
    // AI சந்தா
    aiSubscription: "AI சந்தா",
    aiActivateTitle: "செயற்கை நுண்ணறிவை செயல்படுத்தவும்",
    aiActivateSubtitle: "வாசிப்புகள், வினாடி வினாக்கள் மற்றும் செயல்பாடுகளை தானாக உருவாக்க miabc இன் AI தொகுதிகளைத் திறக்கவும்.",
    aiActiveTitle: "உங்கள் AI சந்தா செயலில் உள்ளது 🎉",
    aiActiveSubtitle: "இப்போது அனைத்து AI தொகுதிகளையும் பயன்படுத்தலாம்.",
    aiValidUntil: "செல்லுபடியாகும் தேதி வரை",
    manageSubscription: "சந்தாவை நிர்வகிக்கவும்",
    manageLocalNote: "உள்ளூர் கட்டணம் மூலம் சந்தா. மாற்றங்கள்/புதுப்பித்தலுக்கு எங்களைத் தொடர்பு கொள்ளவும்.",
    onboardingTitle: "miabconline-க்கு வரவேற்கிறோம்!",
    onboardingSubtitle: "நீங்கள் இன்னும் உங்கள் மாணவரைப் பதிவு செய்யவில்லை. தொடங்க இந்தப் படிகளைப் பின்பற்றவும்.",
    onboardingCodeLabel: "உங்கள் அணுகல் குறியீடு",
    onboardingStep1: "உங்கள் தொலைபேசி அல்லது டேப்லெட்டில் MIABC செயலியைப் பதிவிறக்கவும்.",
    onboardingStep2: "மேலே உள்ள அணுகல் குறியீட்டைப் பயன்படுத்தி உங்கள் மாணவரின் சுயவிவரத்தை உருவாக்கவும்.",
    onboardingStep3: "இங்கு திரும்பி வந்து “என் மாணவரைப் பதிவு செய்துவிட்டேன்” என்பதை அழுத்தி முன்னேற்றத்தைப் பார்க்கவும்.",
    onboardingDownloadApp: "Google Play",
    onboardingEnter: "என் மாணவரைப் பதிவு செய்துவிட்டேன்",
    onboardingHelp: "உதவி தேவையா? எங்களைத் தொடர்பு கொள்ளுங்கள், மகிழ்ச்சியுடன் வழிகாட்டுகிறோம்.",
    portalError: "நிர்வாக போர்ட்டலைத் திறக்க முடியவில்லை.",
    payWithLocal: "வெனிசுலாவில்? Pago Móvil / பணப் பரிமாற்றம் மூலம் செலுத்துங்கள்",
    choosePaymentMethod: "எப்படிச் செலுத்துவது என்பதைத் தேர்வுசெய்யவும்",
    payCardTitle: "அட்டை",
    payCardDesc: "சர்வதேச அட்டை கட்டணம். உடனடியாக செயல்படுத்தப்படும்.",
    payCardBadge: "உடனடி",
    payLocalTitle: "Pago Móvil அல்லது பரிமாற்றம்",
    payLocalDesc: "வெனிசுலாவில் உள்ள உங்கள் வங்கியிலிருந்து. ரசீதைச் சரிபார்த்ததும் செயல்படுத்தப்படும்.",
    payLocalBadge: "வெனிசுலா",
    localPaymentTitle: "Pago Móvil / வங்கி பரிமாற்றம்",
    localPaymentSubtitle: "வெனிசுலாவிலிருந்து செலுத்துங்கள்; ரசீதைச் சரிபார்த்ததும் உங்கள் சந்தாவைச் செயல்படுத்துவோம்.",
    payToAccount: "இந்தக் கணக்கிற்குச் செலுத்துங்கள்",
    referencePrice: "குறிப்பு விலை",
    selectPlan: "திட்டத்தைத் தேர்ந்தெடுக்கவும்",
    paymentReference: "குறிப்பு எண்",
    originBank: "மூல வங்கி",
    amountPaid: "செலுத்திய தொகை",
    paymentDate: "கட்டணத் தேதி",
    uploadProof: "ரசீதைப் பதிவேற்றவும்",
    proofHint: "கட்டணத்தின் படம் (ஸ்கிரீன்ஷாட் அல்லது புகைப்படம்).",
    submitPayment: "ரசீதைச் சமர்ப்பிக்கவும்",
    proofRequired: "நீங்கள் ரசீதைப் பதிவேற்ற வேண்டும்.",
    proofUploadError: "ரசீதைப் பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    paymentUnderReviewTitle: "கட்டணம் பரிசீலனையில்",
    paymentUnderReviewText: "உங்கள் ரசீதைப் பெற்றோம். சரிபார்த்ததும் உங்கள் சந்தாவைச் செயல்படுத்துவோம் (பொதுவாக சில மணிநேரங்களில்).",
    adminPaymentsTitle: "சரிபார்க்க வேண்டிய கட்டணங்கள்",
    statusPending: "நிலுவையில்",
    statusConfirmed: "உறுதிசெய்யப்பட்டது",
    statusRejected: "நிராகரிக்கப்பட்டது",
    notAuthorized: "அங்கீகாரம் இல்லை.",
    noPayments: "காட்ட கட்டணங்கள் இல்லை.",
    viewProof: "ரசீதைப் பார்க்கவும்",
    confirmPayment: "உறுதிசெய்",
    rejectPayment: "நிராகரி",
    rejectReasonPrompt: "நிராகரிப்புக்கான காரணம் (விருப்பம்)",
    paymentConfirmed: "கட்டணம் உறுதிசெய்யப்பட்டு சந்தா செயல்படுத்தப்பட்டது.",
    paymentRejected: "கட்டணம் நிராகரிக்கப்பட்டது.",
    adminSchoolsTitle: "பள்ளிகள்",
    adminLeadsTitle: "பள்ளி கோரிக்கைகள்",
    leadNew: "புதியவை",
    leadContacted: "தொடர்பு கொள்ளப்பட்டவை",
    leadConverted: "மாற்றப்பட்டவை",
    leadDiscarded: "நிராகரிக்கப்பட்டவை",
    noLeads: "கோரிக்கைகள் இல்லை.",
    leadEmail: "மின்னஞ்சல்",
    markContacted: "தொடர்பு கொள்ளப்பட்டது",
    markConverted: "மாற்றப்பட்டது",
    markDiscarded: "நிராகரி",
    adminEventsTitle: "நிகழ்வுகள் கண்காணிப்பு",
    eventsLearners: "கற்பவர்கள்",
    eventsSearch: "பெயர், பயனர்பெயர் அல்லது மின்னஞ்சல் மூலம் தேடுக",
    eventsNoLearners: "இன்னும் நிகழ்வுகள் பதிவு செய்யப்படவில்லை.",
    eventsPickLearner: "நிகழ்வுகளைக் காண ஒரு கற்பவரைத் தேர்ந்தெடுக்கவும்.",
    eventsNone: "இந்தக் கற்பவருக்கு நிகழ்வுகள் இல்லை.",
    eventsFilterName: "அனைத்து நிகழ்வுகளும்",
    eventsLastEvent: "கடைசி நிகழ்வு",
    eventsWhen: "தேதி",
    eventsName: "நிகழ்வு",
    eventsPlatform: "தளம்",
    eventsDetail: "விவரம்",
    eventsLoadMore: "மேலும் ஏற்று",
    eventsRefresh: "புதுப்பி",
    eventsNoName: "பெயர் இல்லை",
    actTitle: "செயல்பாடு:",
    actView: "செயல்பாட்டைக் காண்க",
    actPeriod: "கடந்த 90 நாட்கள்",
    clsTitle: "வகுப்பு செயல்பாடு",
    clsDesc: "செயலியில் யார் பயிற்சி செய்கிறார்கள், யார் செய்யவில்லை. விவரங்களைக் காண ஒரு மாணவரைத் தொடவும்.",
    clsPeriod: "கடந்த 7 நாட்கள்",
    clsAllSections: "அனைத்து பிரிவுகளும்",
    clsActiveWeek: "{total} இல் {n} பேர் இந்த வாரம் பயிற்சி செய்தனர்",
    actNone: "இன்னும் செயல்பாடு இல்லை. மாணவர் செயலியின் சமீபத்திய பதிப்பைப் பயன்படுத்தும்போது இது தோன்றும்.",
    actLast: "கடைசி செயல்பாடு",
    actActiveDays: "செயலில் இருந்த நாட்கள்",
    actTime: "செயலியில் தோராயமான நேரம்",
    actStars: "பெற்ற நட்சத்திரங்கள்",
    actStarsTotal: "மொத்தம்",
    actMastered: "கற்றுத் தேர்ந்தவை",
    actModules: "அதிகம் பயிற்சி செய்தது",
    actHighlights: "புதியவை",
    actFamilyAdded: "{name} ஐ குடும்பத்தில் சேர்த்தார்",
    actWordAdded: "«{word}» என்ற சொல்லைச் சேர்த்தார்",
    actByDay: "நாள்தோறும்",
    actMod_alphabet: "எழுத்துகள்",
    actMod_sounds: "ஒலிகள்",
    actMod_write: "எழுதுதல்",
    actMod_words: "சொற்கள்",
    actMod_complete: "முடிக்க",
    actMod_family: "குடும்பம்",
    actMod_colors: "நிறங்கள்",
    actMod_math: "எண்கள்",
    actMod_shapes: "வடிவங்கள்",
    actMod_read: "படித்தல்",
    actMod_other: "பிற செயல்பாடுகள்",
    newSchool: "புதிய பள்ளி",
    schoolName: "பள்ளியின் பெயர்",
    adminEmailLabel: "பள்ளி கணக்கு மின்னஞ்சல்",
    adminPasswordLabel: "கடவுச்சொல்",
    generate: "உருவாக்கு",
    countryLabel: "நாடு",
    institutionalPlan: "நிறுவன சந்தா (விருப்பம்)",
    priceAmount: "தொகை",
    currency: "நாணயம்",
    interval: "காலம்",
    validUntil: "செல்லுபடியாகும் தேதி வரை",
    createSchool: "பள்ளியை உருவாக்கு",
    schoolCreated: "பள்ளி உருவாக்கப்பட்டது. அறிமுக விவரங்கள் மின்னஞ்சலில் அனுப்பப்பட்டன.",
    existingSchools: "பதிவுசெய்யப்பட்ட பள்ளிகள்",
    noSchools: "இன்னும் பள்ளிகள் இல்லை.",
    manageSchool: "நிர்வகி",
    suspend: "இடைநிறுத்து",
    reactivate: "மீண்டும் இயக்கு",
    renew: "புதுப்பி",
    resetPassword: "கடவுச்சொல்லை மீட்டமை",
    students: "மாணவர்கள்",
    subscriptionLabel: "சந்தா",
    suspendConfirm: "இந்தப் பள்ளியை இடைநிறுத்தவா? அனைத்து பயனர்களுக்கும் AI நீக்கப்படும்.",
    newPasswordGenerated: "புதிய கடவுச்சொல்",
    close: "மூடு",
    schoolSuspended: "பள்ளி இடைநிறுத்தப்பட்டது.",
    schoolReactivated: "பள்ளி மீண்டும் இயக்கப்பட்டது.",
    schoolRenewed: "சந்தா புதுப்பிக்கப்பட்டது.",
    schoolPanelTitle: "என் பள்ளி",
    teacherPanelTitle: "என் பிரிவுகள்",
    teachers: "ஆசிரியர்கள்",
    teacherName: "ஆசிரியர் பெயர்",
    addTeacher: "ஆசிரியரைச் சேர்",
    noTeachers: "இன்னும் ஆசிரியர்கள் இல்லை.",
    teacherCreated: "ஆசிரியர் உருவாக்கப்பட்டார்.",
    docType: "வகை",
    docNumber: "அடையாள எண் / ஆவணம்",
    optional: "விருப்பம்",
    importTeachers: "இறக்குமதி",
    importHelp: "ஒரு வரிக்கு ஒருவர்: பெயர், அடையாள எண், மின்னஞ்சல் (கமா அல்லது டேப் மூலம் பிரிக்கவும்). மின்னஞ்சலும் அடையாள எண்ணும் தானாகக் கண்டறியப்படும்.",
    importAutoEmail: "அடையாள எண்ணிலிருந்து மின்னஞ்சல்களைத் தானாக உருவாக்கு",
    importAutoEmailHint: "மின்னஞ்சல் இல்லாதவர்களுக்கு மட்டும்",
    importPreview: "முன்னோட்டம்",
    importValid: "செல்லுபடியாகும்",
    importNoName: "பெயர் இல்லை",
    importNoEmail: "மின்னஞ்சல் இல்லை",
    importCreated: "உருவாக்கப்பட்டவை",
    importSkipped: "தவிர்க்கப்பட்டவை",
    importFailed: "தோல்வி",
    copyCredentials: "சான்றுகளை நகலெடு",
    copied: "நகலெடுக்கப்பட்டது",
    pageWord: "பக்கம்",
    teachersDesc: "தளத்திற்கு அணுகல் உள்ள உங்கள் பள்ளியின் ஆசிரியர்கள்.",
    gradesDesc: "உங்கள் பள்ளியின் நிலைகள். ஒவ்வொரு மாணவரும் ஒரு வகுப்பைச் சேர்ந்தவர்.",
    sectionsDesc: "ஒவ்வொரு பிரிவும் ஒரு வகுப்பை அதன் ஆசிரியர்கள் மற்றும் மாணவர்களுடன் இணைக்கிறது.",
    studentsDesc: "உங்கள் பள்ளியின் மாணவர்கள். அவர்கள் ஒரு வகுப்பைச் சேர்ந்து ஒரு பிரிவில் சேர்க்கப்படுகிறார்கள்.",
    teachersEmptyHint: "மேலே முதல் ஆசிரியரைச் சேர்க்கவும் அல்லது தொகுப்பாக இறக்குமதி செய்யவும்.",
    gradesEmptyHint: "உங்கள் பள்ளியின் வகுப்புகளை உருவாக்கவும் (எ.கா. 1ஆம் வகுப்பு).",
    sectionsEmptyHint: "ஒரு பிரிவை உருவாக்கி, வகுப்பையும் ஆசிரியர்களையும் ஒதுக்கவும்.",
    studentsEmptyHint: "முதல் மாணவரைச் சேர்க்கவும் அல்லது தொகுப்பாக இறக்குமதி செய்யவும்.",
    actionsCol: "செயல்கள்",
    noGradesYet: "முதலில் ஒரு வகுப்பை உருவாக்கவும்",
    sectionsNeedGrade: "பிரிவுகளுக்கு குறைந்தது ஒரு வகுப்பு தேவை. வகுப்புகளுக்குச் சென்று உருவாக்கவும்.",
    studentsNeedGrade: "ஒவ்வொரு மாணவரும் ஒரு வகுப்பைச் சேர்ந்திருக்க வேண்டும். முதலில் வகுப்பை உருவாக்கவும்.",
    selectGrade: "ஒரு வகுப்பைத் தேர்ந்தெடுக்கவும்",
    noSection: "பிரிவு இல்லை",
    section: "பிரிவு",
    enrollStudents: "மாணவர்களைச் சேர்",
    pickGradeFirst: "அதன் மாணவர்களைப் பார்க்க ஒரு வகுப்பைத் தேர்ந்தெடுக்கவும்.",
    noStudentsInGrade: "இந்த வகுப்பில் இன்னும் மாணவர்கள் இல்லை.",
    importStudents: "மாணவர்களை இறக்குமதி செய்",
    editStudent: "மாணவரைத் திருத்து",
    deleteStudentConfirm: "இந்த மாணவரை நீக்கவா?",
    viewDetails: "விவரங்களைக் காண்",
    teacherDetail: "ஆசிரியர் விவரம்",
    studentDetail: "மாணவர் விவரம்",
    editTeacher: "ஆசிரியரைத் திருத்து",
    noSectionsAssigned: "பிரிவுகள் ஒதுக்கப்படவில்லை.",
    studentLoginNote: "இந்த சான்றுகள் MiABC மொபைல் செயலியில் உள்நுழைய பயன்படும்.",
    // ── பிரதிநிதிகள் (படிக்க-மட்டும் பாதுகாவலர்கள்) ──
    representatives: "பிரதிநிதிகள்",
    representativesDesc: "மாணவர்களின் முன்னேற்றத்தைப் பின்தொடரும் பாதுகாவலர்கள். படிக்க-மட்டும் வலை அணுகல்.",
    representativeName: "பிரதிநிதியின் பெயர்",
    representativeEmail: "பிரதிநிதியின் மின்னஞ்சல்",
    addRepresentative: "பிரதிநிதியைச் சேர்",
    representativeCreated: "பிரதிநிதி உருவாக்கப்பட்டது.",
    noRepresentatives: "இன்னும் பிரதிநிதிகள் இல்லை.",
    representativesEmptyHint: "ஒரு பிரதிநிதியை உருவாக்கி ஒன்று அல்லது பல மாணவர்களை ஒதுக்கவும்.",
    representativesNeedStudents: "ஒதுக்குவதற்கு முதலில் பள்ளியில் மாணவர்களைச் சேர்க்கவும்.",
    editRepresentative: "பிரதிநிதியைத் திருத்து",
    deleteRepresentativeConfirm: "இந்தப் பிரதிநிதியை நீக்கவா?",
    representativeDetail: "பிரதிநிதி விவரம்",
    assignStudents: "மாணவர்களை ஒதுக்கு",
    assignedStudents: "ஒதுக்கப்பட்ட மாணவர்கள்",
    noStudentsAssigned: "மாணவர்கள் ஒதுக்கப்படவில்லை.",
    searchStudent: "மாணவரைத் தேடு…",
    noStudentsYet: "இன்னும் மாணவர்கள் இல்லை",
    myStudents: "என் மாணவர்கள்",
    representativePanelDesc: "உங்கள் மாணவர்களின் முன்னேற்றத்தைப் பின்தொடருங்கள்: கடைசி அணுகல், இணைப்புகள், சொற்கள்.",
    repEyebrow: "பிரதிநிதி",
    noStudentsRep: "உங்களுக்கு இன்னும் மாணவர்கள் ஒதுக்கப்படவில்லை. பள்ளியிடம் கேளுங்கள்.",
    noTeachersAssigned: "ஆசிரியர்கள் ஒதுக்கப்படவில்லை.",
    noStudentsInSection: "இன்னும் மாணவர்கள் சேர்க்கப்படவில்லை.",
    resetPasswordConfirm: "கடவுச்சொல்லை மீட்டமைக்கவா?",
    resetPasswordConfirmText: "புதிய கடவுச்சொல் உருவாக்கப்படும், தற்போதையது செயல்படாது.",
    students: "மாணவர்கள்",
    studentName: "மாணவரின் பெயர்",
    studentEmail: "மாணவரின் மின்னஞ்சல்",
    teacherEmail: "ஆசிரியரின் மின்னஞ்சல்",
    addStudent: "மாணவரைச் சேர்",
    noStudents: "இன்னும் மாணவர்கள் இல்லை.",
    studentCreated: "மாணவர் உருவாக்கப்பட்டார்.",
    edit: "திருத்து",
    delete: "நீக்கு",
    save: "சேமி",
    resetPassword: "கடவுச்சொல்லை மீட்டமை",
    editSection: "பிரிவைத் திருத்து",
    deleteTeacherConfirm: "இந்த ஆசிரியரை நீக்கவா?",
    deleteSectionConfirm: "இந்தப் பிரிவை நீக்கவா?",
    sectionHasStudents: "பிரிவில் மாணவர்கள் உள்ளனர். முதலில் அவர்களை நகர்த்தவும் அல்லது நீக்கவும்.",
    grades: "வகுப்புகள்",
    gradeName: "வகுப்பின் பெயர்",
    addGrade: "சேர்",
    noGrades: "இன்னும் வகுப்புகள் இல்லை.",
    editGrade: "வகுப்பைத் திருத்து",
    deleteGradeConfirm: "இந்த வகுப்பை நீக்கவா?",
    gradeHasSections: "வகுப்பில் பிரிவுகள் உள்ளன. முதலில் அவற்றை நீக்கவும்.",
    viewStudents: "மாணவர்களைப் பார்க்கவும்",
    sections: "பிரிவுகள்",
    sectionName: "பிரிவின் பெயர்",
    grade: "வகுப்பு",
    assignTeachers: "ஆசிரியர்களை ஒதுக்கு",
    addSection: "பிரிவைச் சேர்",
    noSections: "இன்னும் பிரிவுகள் இல்லை.",
    noSectionsTeacher: "உங்களுக்கு இன்னும் பிரிவுகள் ஒதுக்கப்படவில்லை.",
    teacherEyebrow: "என் பலகை",
    teacherPanelDesc: "உங்கள் பிரிவுகளும் ஒவ்வொரு மாணவரின் கண்காணிப்பும்: கடைசி அணுகல், இணைப்புகள், செயல்பாடு.",
    colLastAccess: "கடைசி அணுகல்",
    colConnections: "இணைப்புகள்",
    colStatus: "நிலை",
    wordsCol: "சொற்கள்",
    viewWords: "மாணவரின் சொற்களைக் காண்",
    studentWordsTitle: "சொற்கள் —",
    stActive: "செயலில்",
    stInactive: "செயலற்ற",
    stNever: "தொடங்கவில்லை",
    daysShort: "நா",
    neverWord: "ஒருபோதும்",
    summaryActive: "செயலில்",
    summaryConns: "இணைப்புகள்",
    teacherAuthorSoon: "விரைவில்: இங்கிருந்து முழு பிரிவுக்கும் சொற்கள், உரைகள், அனுமானம் உருவாக்கலாம்.",
    teacherAuthorHint: "ஒரு உரையை உருவாக்கினால் இந்தப் பிரிவின் அனைத்து மாணவர்களுக்கும் பகிரப்படும்.",
    teacherAuthorTitle: "உங்கள் மாணவர்களுக்கு உள்ளடக்கம் உருவாக்கு",
    teacherAuthorBody: "பெற்றோரைப் போலவே உரைகளும் அனுமானமும் உருவாக்கவும். பிறகு உங்கள் உரைப் பட்டியல் அல்லது சேமித்த உள்ளடக்கங்களில் இருந்து 'பகிர்' பொத்தானால் முழு பிரிவுக்கும் அனுப்பவும்.",
    distributeTooltip: "ஒரு பிரிவுக்கு பகிர்",
    distributeTitle: "ஒரு பிரிவுக்கு பகிர்",
    distributeText: "நீங்கள் தேர்ந்தெடுக்கும் பிரிவின் அனைத்து மாணவர்களுக்கும் அனுப்பப்படும்.",
    distributeSelect: "ஒரு பிரிவைத் தேர்ந்தெடு",
    distributeConfirm: "பகிர்",
    distributing: "பகிர்கிறது…",
    distributeDoneTitle: "பகிரப்பட்டது!",
    distributeDoneA: "அனுப்பப்பட்டது",
    distributeAppNote: "மொபைல் செயலியில் உள்நுழையும்போது இதைக் காண்பார்கள்.",
    distributeNoSectionsTitle: "பிரிவுகள் இல்லை",
    distributeNoSections: "உள்ளடக்கத்தைப் பகிர இன்னும் பிரிவுகள் ஒதுக்கப்படவில்லை.",
    genForSection: "பிரிவுக்கு உரை உருவாக்கு",
    genModalHint: "AI மூலம் ஒரே முறை உருவாக்கி பிரிவின் ஒவ்வொரு மாணவருக்கும் பகிரப்படும். அவர்களின் செயலியில் தோன்றும்.",
    genBaseText: "அடிப்படை உரை (வாசிப்பு)",
    genBasePlaceholder: "கேள்விகள் உருவாக்கப்படும் வாசிப்பு உரையை ஒட்டவும் அல்லது தட்டச்சு செய்யவும்…",
    genLevels: "புளூம் நிலைகள்",
    genPerLevel: "ஒரு நிலைக்கு கேள்விகள்",
    genDifficulty: "கடினத்தன்மை",
    genLanguage: "மொழி",
    genGenerate: "உருவாக்கி பகிர்",
    genGenerating: "உருவாக்குகிறது…",
    genDone: "உரை பகிரப்பட்டது!",
    genDistributedA: "பகிரப்பட்டது",
    genQuestions: "கேள்விகள்",
    genAppNote: "மாணவர்கள் MiABC மொபைல் செயலியில் உள்நுழையும்போது இதைக் காண்பார்கள்.",
    level_recordar: "நினைவுகூர்",
    level_entender: "புரிந்துகொள்",
    level_aplicar: "பயன்படுத்து",
    level_analizar: "பகுப்பாய்",
    level_evaluar: "மதிப்பிடு",
    level_crear: "உருவாக்கு",
    "diff_fácil": "எளிது",
    diff_medio: "நடுத்தரம்",
    "diff_difícil": "கடினம்",
    genInfForSection: "அனுமானம் உருவாக்கு",
    infModalHint: "ஒரு அனுமானப் பாடத்தை (படம் + வாசிப்பு + கேள்விகள்) ஒரே முறை உருவாக்கி முழு பிரிவுக்கும் பகிரப்படும்.",
    infIdea: "பாடத்தின் யோசனை அல்லது தலைப்பு",
    infIdeaPlaceholder: "எ.கா.: பண்ணை விலங்குகளும் அவற்றின் ஒலிகளும்…",
    infNumQ: "கேள்விகள்",
    infNumImgQ: "பட கேள்விகள்",
    infImgDiff: "பட கடினம்",
    infGenerate: "பாடம் உருவாக்கு",
    infGenerating: "உருவாக்குகிறது (சிறிது நேரம் ஆகலாம்)…",
    infPreview: "பாட முன்னோட்டம்",
    infImgQuestions: "படம்",
    infVocab: "சொற்களஞ்சியம்",
    infReadyHint: "பாடத்தை சரிபார்க்கவும். பகிரும்போது படம் சேமிக்கப்பட்டு ஒவ்வொரு மாணவருக்கும் சேரும்.",
    infBack: "பின்செல்",
    infDistribute: "பிரிவுக்கு பகிர்",
    infDistributing: "பகிர்கிறது…",
    studentsComingSoon: "மாணவர்கள்: விரைவில்",
    planMonthly: "மாதாந்திர",
    planAnnual: "ஆண்டுதோறும்",
    perMonth: "/மாதம்",
    perYear: "/ஆண்டு",
    bestValue: "சிறந்த மதிப்பு",
    planMonthlyNote: "மாதந்தோறும் கட்டணம். எப்போது வேண்டுமானாலும் ரத்து செய்யலாம்.",
    planAnnualNote: "$3.33/மாதம் சமம் — ~33% சேமிக்கவும்.",
    aiFeature1: "படங்களுடன் வாசிப்பு உருவாக்கம் (அனுமானம்)",
    aiFeature2: "ப்ளூமின் வகைப்பாட்டுடன் வினாடி வினாக்கள்",
    aiFeature3: "AI உதவியுடன் கேள்விகள் மற்றும் பதில்கள்",
    aiFeature4: "தானியங்கி சொற்களஞ்சியம் மற்றும் செயல்பாடுகள்",
    activateAi: "AI ஐ செயல்படுத்தவும்",
    paywallTitle: "இந்த அம்சத்திற்கு செயலில் உள்ள AI தேவை",
    paywallText: "இந்த தொகுதியைப் பயன்படுத்த உங்களுக்கு செயலில் உள்ள AI சந்தா தேவை.",
    paywallButton: "திட்டங்களைப் பார்த்து AI ஐ செயல்படுத்தவும்",
    checkoutError: "கட்டணத்தைத் தொடங்க முடியவில்லை.",
    sessionInvalid: "தவறான அமர்வு. மீண்டும் உள்நுழையவும்.",

    // Navigation and general
    language: "மொழி",
    spanish: "ஸ்பானிஷ்",
    english: "ஆங்கிலம்",
    tamil: "தமிழ்",

    // File upload
    uploadFile: "கோப்பை பதிவேற்றவும்",
    or: "அல்லது",
    dragDropFile: "இங்கே ஒரு கோப்பை இழுத்து விடவும், அல்லது தேர்ந்தெடுக்க கிளிக் செய்யவும்",
    supportedFormats: "ஆதரிக்கப்படும் வடிவங்கள்: PDF, DOCX",
    fileSizeLimit: "அதிகபட்ச கோப்பு அளவு: 10MB",
    extractingText: "உரையை பிரித்தெடுக்கிறது...",
    fileUploadError: "கோப்பை பதிவேற்றுவதில் பிழை",
    invalidFileType: "தவறான கோப்பு வகை. தயவுசெய்து PDF அல்லது DOCX கோப்புகளை மட்டும் பதிவேற்றவும்.",
    fileTooLarge: "கோப்பு மிகப் பெரியது. அதிகபட்ச அளவு 10MB.",
    removeFile: "கோப்பை அகற்று",
    uploadedFile: "பதிவேற்றப்பட்ட கோப்பு",
    noFileSelected: "கோப்பு தேர்ந்தெடுக்கப்படவில்லை",

    // Main pages
    login: "உள்நுழைய",
    register: "பதிவு செய்யவும்",
    forgotPassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா",
    dashboard: "முகப்பு பலகை",

    welcome: "வரவேற்பு!",
    email: "மின்னஞ்சல்",
    password: "கடவுச்சொல்",
    loginButton: "உள்நுழைய",
    forgotPassword: "உங்கள் கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    noAccount: "கணக்கு இல்லையா?",
    privacyText: "உள்நுழைவதன் மூலம், நீங்கள் எங்கள்",
    privacyPolicy: "தனியுரிமைக் கொள்கையை ஏற்றுக்கொள்கிறீர்கள்",

    otpTabPassword: "கடவுச்சொல்",
    otpTabCode: "மின்னஞ்சல் குறியீடு",
    otpSendCode: "எனக்கு குறியீடு அனுப்பு",
    otpSending: "அனுப்புகிறது…",
    otpSentTo: "நாங்கள் அனுப்பிய 6 இலக்க குறியீட்டை உள்ளிடவும்:",
    otpVerify: "சரிபார்த்து உள்நுழைய",
    otpVerifying: "சரிபார்க்கிறது…",
    otpResend: "குறியீட்டை மீண்டும் அனுப்பு",
    otpResendIn: "மீண்டும் அனுப்ப",
    otpChangeEmail: "வேறு மின்னஞ்சலைப் பயன்படுத்து",
    otpCheckSpam: "காணவில்லையா? உங்கள் spam கோப்புறையைப் பார்க்கவும்.",
    otpSentToast: "மின்னஞ்சலுக்கு கணக்கு இருந்தால், குறியீட்டை அனுப்பினோம்.",
    otpErrInvalidEmail: "சரியான மின்னஞ்சலை உள்ளிடவும்.",
    otpErrSend: "குறியீட்டை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    otpErrWrong: "தவறான குறியீடு. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    otpErrExpired: "குறியீடு காலாவதியானது. புதியதைக் கோரவும்.",
    otpErrTooMany: "அதிக முயற்சிகள். புதிய குறியீட்டைக் கோரவும்.",
    otpErrNoCode: "முதலில் குறியீட்டைக் கோரவும்.",

    learnerNotRegistered: "கற்பவர் இன்னும் மொபைல் செயலியில் பதிவு செய்யப்படவில்லை, இந்த தளத்தை அணுக பதிவை முடிக்க வேண்டும்.",
    noAccess: "இந்த பயனருக்கு இந்த தளத்திற்கான அணுகல் இல்லை.",
    verifyData: "உங்கள் தரவை சரிபார்க்கவும்",

    createAccount: "கணக்கை உருவாக்கவும்!",
    selectRolePlaceholder: "உங்கள் பங்கை தேர்ந்தெடுக்கவும்",
    errInvalidCode: "குறியீடு தவறானது, சரிபார்த்து மீண்டும் முயற்சிக்கவும்",
    errCodeInUse: "இந்தக் குறியீடு ஏற்கனவே பயன்பாட்டில் உள்ளது, சரிபார்த்து மீண்டும் முயற்சிக்கவும்",
    errEmailInUse: "இந்த மின்னஞ்சல் ஏற்கனவே பயன்பாட்டில் உள்ளது",
    errUserNotFound: "இந்தப் பயனர் பதிவு செய்யப்படவில்லை",
    errInvalidEmail: "தவறான மின்னஞ்சல்",
    errTooManyRequests: "சில நிமிடங்களில் மீண்டும் முயற்சிக்கவும்",
    errMissingEmail: "மின்னஞ்சல் புலம் காலியாக இருக்கக்கூடாது",
    errUnexpected: "எதிர்பாராத பிழை ஏற்பட்டது",
    errAvatarRequired: "சுயவிவரப் படத்தைப் பதிவேற்ற வேண்டும், படி 2க்குத் திரும்பவும்",
    errRoleRequired: "ஒரு பங்கைத் தேர்ந்தெடுக்க வேண்டும், படி 1க்குத் திரும்பவும்",
    errAvatarUpload: "சுயவிவரப் படத்தைப் பதிவேற்ற முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    errCheckConnection: "உங்கள் இணைப்பைச் சரிபார்க்கவும்",
    errorTitle: "பிழை",
    contentFormatError: "உருவாக்கப்பட்ட உள்ளடக்கம் தவறான வடிவத்தில் உள்ளது.",
    parent: "பெற்றோர்",
    teacher: "ஆசிரியர்",
    roleRequired: "பங்கு தேவை",
    next: "அடுத்து",
    back: "பின்னால்",
    alreadyHaveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
    signIn: "உள்நுழைக.",
    privacyRegisterText: "பதிவு செய்வதன் மூலம், நீங்கள் எங்கள்",

    profileImageRequired: "சுயவிவர படம் தேவை",
    accessCode: "அணுகல் குறியீடு",
    accessCodeRequired: "அணுகல் குறியீடு தேவை",
    nameEmail: "பெயர் / மின்னஞ்சல்",
    emailRequired: "மின்னஞ்சல் தேவை",
    passwordRequired: "கடவுச்சொல் தேவை",

    emailInUse: "மின்னஞ்சல் ஏற்கனவே பயன்பாட்டில் உள்ளது.",
    invalidEmail: "தவறான மின்னஞ்சல்.",
    weakPassword: "கடவுச்சொல் பலவீனமானது.",
    tooManyRequests: "ஒரு நிமிடத்தில் மீண்டும் முயற்சிக்கவும்.",
    checkConnection: "உங்கள் இணைப்பைச் சரிபார்க்கவும்.",

    generalInfo: "பொதுவான தகவல்",
    username: "பயனர்பெயர்",
    grade: "வகுப்பு",
    apprenticeName: "மாணவர் பெயர்",
    congratulatoryPhrase: "வாழ்த்து வாக்கியம்",
    lastLogin: "கடைசி உள்நுழைவு",
    updateNote: "மொபைல் செயலியில் வெளியேறும்போது மட்டுமே புதுப்பிக்கப்படும்",

    // Login forms
    confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    registerButton: "பதிவு செய்யவும்",
    forgotPasswordButton: "கடவுச்சொல்லை மீட்டெடுக்கவும்",
    emailSentSuccess: "மின்னஞ்சல் வெற்றிகரமாக அனுப்பப்பட்டது",
    checkInbox: "உங்கள் இன்பாக்ஸைச் சரிபார்த்து வழிமுறைகளைப் பின்பற்றவும்",
    restartPassword: "கடவுச்சொல்லை மீட்டமைக்கவும்",
    sendInstructions: "அறிவுறுத்தல்களை அனுப்பவும்",

    // Dashboard navigation
    wordsCreated: "உருவாக்கப்பட்ட சொற்கள்",
    wordsReceived: "பெறப்பட்ட சொற்கள்",
    wordsSent: "அனுப்பப்பட்ட சொற்கள்",
    familyCreated: "குடும்பம் உருவாக்கப்பட்டது",
    createText: "உரையை உருவாக்கவும்",
    listTexts: "உரை பட்டியல்",
    downloads: "பதிவிறக்கங்கள்",

    // Common messages
    loading: "ஏற்றுகிறது...",
    save: "சேமிக்கவும்",
    cancel: "ரத்து செய்",
    edit: "திருத்து",
    delete: "நீக்கு",
    search: "தேடு",
    deleteConfirmation: "நீக்குதலை உறுதிப்படுத்தவா?",
    cannotRevertAction: "இந்த செயலை மாற்ற முடியாது",
    yesDelete: "ஆம், நீக்கு",
    deletedSuccessfully: "வெற்றிகரமாக நீக்கப்பட்டது",

    // Terms and privacy
    privacy: "தனியுரிமை",
    terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",

    // Educational app
    appTitle: "My ABC Online | கல்வி பயன்பாடு",
    educationalApp: "கல்வி பயன்பாடு",

    // Error and success messages
    error: "பிழை",
    success: "வெற்றி",
    invalidCredentials: "தவறான சான்றுகள்",
    passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",

    // Words and lists
    words: "சொற்கள்",
    texts: "உரைகள்",
    family: "குடும்பம்",
    syllables: "எழுத்துக்கள்",
    topic: "தலைப்பு",
    sentTo: "அனுப்பப்பட்டது",
    sentBy: "அனுப்பியவர்",
    details: "விவரங்கள்",
    actions: "செயல்கள்",
    create: "உருவாக்கு",
    previous: "முந்தைய",

    // Page titles
    wordsCreatedList: "உருவாக்கப்பட்ட சொற்கள் பட்டியல்",
    wordsReceivedList: "பெறப்பட்ட சொற்கள் பட்டியல்",
    wordsSentList: "அனுப்பப்பட்ட சொற்கள் பட்டியல்",
    familyMembersList: "சேர்க்கப்பட்ட உறுப்பினர்கள் பட்டியல்",
    readingTextsCreated: "உருவாக்கப்பட்ட வாசிப்பு உரைகள்",
    numberOfQuestions: "கேள்விகளின் எண்ணிக்கை",

    // Messages
    noWordsReceived: "சொற்கள் எதுவும் பெறப்படவில்லை.",
    from: "இருந்து",

    // Downloads
    downloadsDocumentation: "ஆவண பதிவிறக்கங்கள்",
    downloadInfo: "இங்கே நீங்கள் சில ஆதரவு ஆவணங்களைப் பதிவிறக்கலாம்.",
    information: "தகவல்",
    downloading: "பதிவிறக்குகிறது...",
    downloaded: "பதிவிறக்கப்பட்டது",
    downloadPDF: "PDF பதிவிறக்கவும்",
    downloadCompleted: "பதிவிறக்கம் முடிந்தது!",
    fileDownloadedSuccessfully: "வெற்றிகரமாக பதிவிறக்கப்பட்டது.",
    accept: "ஏற்கவும்",
    downloadingFiles: "கோப்புகளை பதிவிறக்குகிறது",
    downloadAllStarted: "அனைத்து கோப்புகளின் பதிவிறக்கம் தொடங்கியது",

    // Text creation
    createReadingText: "வாசிப்புக்கான உரையை உருவாக்கவும்",
    editTextContent: "உரை உள்ளடக்கத்தைத் திருத்தவும்",
    textContent: "உரை உள்ளடக்கம்",
    numberOfQuestionsLabel: "கேள்விகளின் எண்ணிக்கை",
    questionType: "கேள்வி வகை",
    difficulty: "சிரமம்",
    format: "வடிவம்",
    language: "மொழி",
    generateQuestions: "கேள்விகளை உருவாக்கவும்",
    generating: "உருவாக்குகிறது...",
    deleteSelected: "தேர்ந்தெடுத்ததை நீக்கு",
    resetForm: "படிவத்தை மீட்டமைக்கவும்",
    saveText: "உரையை சேமிக்கவும்",
    updateText: "உரையை புதுப்பிக்கவும்",

    // Form options
    selectDifficulty: "சிரமத்தை தேர்ந்தெடுக்கவும்",
    easy: "எளிது",
    medium: "நடுத்தரம்",
    difficult: "கடினம்",
    hard: "மிகக் கடினம்",
    selectFormat: "வடிவத்தை தேர்ந்தெடுக்கவும்",
    multipleChoice: "பல தேர்வு",
    trueFalse: "உண்மை/பொய்",
    openFormat: "திறந்த வடிவம்",
    selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
    open: "திறந்த",
    bloomsTaxonomy: "ப்ளூமின் வகைபிரித்தல்",
    formatHelp: "வினாத்தாள் வடிவத்தை தேர்ந்தெடுக்கவும், இது திறந்த அல்லது ப்ளூம்ஸ் வகைப்பாட்டை அடிப்படையாகக் கொண்டதாக இருக்கலாம்.",
    moduleInfo: "இந்த தொகுதியில் நீங்கள் ஒரு உரையிலிருந்து கேள்விகள் மற்றும் அவற்றின் பதில்களை உருவாக்கலாம்.",
    introduceText: "உரையை உள்ளிடவும்",
    textHelp: "கேள்விகள் உருவாக்கப்படும் உரையை உள்ளிடவும்.",
    selectQuestionType: "கேள்வி வகையைத் தேர்ந்தெடுக்கவும்",
    trueFalse: "உண்மை அல்லது பொய்",
    openAnswer: "திறந்த பதில்",
    selectDifficulty: "கேள்வி சிரம நிலையைத் தேர்ந்தெடுக்கவும்",
    limitQuestions: "கேள்விகளின் எண்ணிக்கையை வரம்பிடவும்:",
    limitHelp: "நீங்கள் உருவாக்க விரும்பும் அதிகபட்ச கேள்விகளின் எண்ணிக்கையை உள்ளிடவும், 0 அதிகபட்சம் சாத்தியமானதை உருவாக்கும்.",
    selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
    spanish: "ஸ்பானிஷ்",
    english: "ஆங்கிலம்",
    tamil: "தமிழ்",
    languageHelp: "நீங்கள் முடிவுகளை விரும்பும் மொழியைத் தேர்ந்தெடுக்கவும்.",
    regenerate: "மீண்டும் உருவாக்கவும்",
    results: "முடிவுகள்:",
    clickQuestions:
      "விவரங்களை விரிவாக்க கேள்விகளைக் கிளிக் செய்யவும். ஏதேனும் கேள்வியை நீக்க விரும்பினால் தேர்வுப்பெட்டிகளைக் கிளிக் செய்யவும்.",
    removeSelected: "தேர்ந்தெடுத்ததை அகற்று",
    options: "விருப்பங்கள்:",
    answer: "பதில்:",
    true: "உண்மை",
    false: "பொய்",
    noQuestionsGenerated: "இன்னும் கேள்விகள் மற்றும் பதில்கள் உருவாக்கப்படவில்லை.",
    generatePDF: "PDF உருவாக்கி அச்சிடவும்",
    generatePDFWithAnswers: "PDF ஐ உருவாக்கி அச்சிடவும் (பதில்களுடன்)",
    generatePDFNoAnswers: "PDF ஐ உருவாக்கி அச்சிடவும் (பதில்கள் இல்லாமல்)",
    update: "புதுப்பிக்கவும்",
    reset: "மீட்டமைக்கவும்",
    clear: "அழிக்கவும்",
    bloomsModuleInfo:
      "இந்த தொகுதியில் நீங்கள் ஒரு உரையிலிருந்து மற்றும் ப்ளூம்ஸ் வகைப்பாட்டின் அடிப்படையில் கேள்விகள் மற்றும் அவற்றின் பதில்களை உருவாக்கலாம்.",
    selectLevels: "நிலைகளைத் தேர்ந்தெடுக்கவும்",
    create: "உருவாக்கு",
    evaluate: "மதிப்பீடு செய்",
    analyze: "பகுப்பாய்வு செய்",
    apply: "பயன்படுத்து",
    understand: "புரிந்துகொள்",
    remember: "நினைவில் கொள்",
    levelsHelp:
      "கேள்விகளில் உருவாக்கப்பட வேண்டிய புளூம்ஸ் வகைப்பாட்டியல் (Bloom's Taxonomy) நிலைகளைத் தேர்ந்தெடுக்கவும்; எந்த நிலையையும் தேர்ந்தெடுக்கவில்லை எனில், அனைத்து நிலைகளுக்கும் கேள்விகள் உருவாக்கப்படும். உருவாக்க விரும்பும் நிலைகளைத் தேர்ந்தெடுக்கவும், எந்த நிலையும் தேர்ந்தெடுக்காமல் இருந்தால் அனைத்துக்கும் கேள்விகள் உருவாக்கப்படும்.",
    limitBloomsHelp: "ஒரு நிலைக்கு நீங்கள் உருவாக்க விரும்பும் அதிகபட்ச கேள்விகளின் எண்ணிக்கையை உள்ளிடவும், அதிகபட்சம் 8.",
    inferenceLearning: "ஊகம் மூலம் கற்றல்",
    inferenceIdeaLabel: "படத்திற்கான யோசனை அல்லது கருத்து",
    inferenceIdeaPlaceholder: "உதாரணம்: பேசும் விலங்குகள் கொண்ட ஒரு மாயக் காடு...",
    numQuestionsPerLevelLabel: "ஒவ்வொரு புளூம்ஸ் நிலைக்கும் கேள்விகள்",
    questionsPerLevelHelp: "தேர்ந்தெடுக்கப்பட்ட ஒவ்வொரு புளூம்ஸ் நிலைக்கும் இந்தக் கேள்விகள் உருவாக்கப்படும்.",
    questionsTotalWord: "மொத்தக் கேள்விகள்",
    inferenceReadingText: "வாசிப்பு உரை",
    inferenceQuestions: "ஊகக் கேள்விகள்",
    generateInference: "ஊகத்தை உருவாக்கு",
    vocabularyList: "சொற்களஞ்சியம்",
    discard: "நிராகரி",
    save: "சேமி",
    saving: "சேமிக்கிறது...",

    // CreateTextContainer messages
    unexpectedError: "எதிர்பாராத பிழை ஏற்பட்டது.",
    updatedSuccessfully: "வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    savedSuccessfully: "வெற்றிகரமாக சேமிக்கப்பட்டது.",
    completeFieldsAndGenerate: "தொடர இரண்டு புலங்களையும் முடித்து கேள்விகளை உருவாக்கவும்.",
    editTextContent: "உரை உள்ளடக்கத்தைத் திருத்தவும்",
    createTextForReading: "வாசிப்புக்கான உரையை உருவாக்கவும்",
    selectDifficultyFirst: "தயவுசெய்து கேள்விகளின் சிரம நிலையைத் தேர்ந்தெடுக்கவும்.",
    introduceTextFirst: "தயவுசெய்து உரையை உள்ளிடவும் கேள்விகளை உருவாக்கும் முன்.",
    selectLanguageFirst: "தயவுசெய்து மொழியை உள்ளிடவும் கேள்விகளை உருவாக்கும் முன்.",
    selectQuestionTypeFirst: "உருவாக்கும் முன் கேள்வி வகையைத் தேர்ந்தெடுக்கவும்.",
    introduceLimitFirst: "தயவுசெய்து கேள்வி வரம்பை உள்ளிடவும் கேள்விகளை உருவாக்கும் முன்.",
    questionsLimitExceeded: "கேள்விகளின் வரம்பு மீறப்பட்டது.",

    // Terms/Privacy Policy page
    privacyPolicy: "தனியுரிமைக் கொள்கை",
    introduction: "அறிமுகம்",
    welcomeText:
      "MiABC க்கு வரவேற்கிறோம்! குழந்தைகளுக்கு பாதுகாப்பான மற்றும் இனிமையான கற்றல் அனுபவத்தை வழங்க நாங்கள் அர்ப்பணிக்கப்பட்டுள்ளோம். உங்கள் குழந்தையின் தனியுரிமையைப் பாதுகாப்பது எங்களுக்கு முன்னுரிமை. எங்கள் பயன்பாட்டைப் பயன்படுத்தும் 13 வயதுக்குட்பட்ட குழந்தைகளின் தனிப்பட்ட தகவல்களை நாங்கள் எவ்வாறு சேகரிக்கிறோம், பயன்படுத்துகிறோம் மற்றும் பாதுகாக்கிறோம் என்பதை இந்த தனியுரிமைக் கொள்கை விளக்குகிறது.",
    informationWeCollect: "நாங்கள் சேகரிக்கும் தகவல்",
    personalInformation: "தனிப்பட்ட தகவல்",
    personalInfoText:
      "பெற்றோரின் அனுமதியின்றி குழந்தைகளிடமிருந்து தனிப்பட்ட தகவல்களை நேரடியாக சேகரிக்கவில்லை. தனிப்பட்ட தகவலில் அடங்கும்:",
    contactInfo:
      "பெற்றோர்/பாதுகாவலர் தொடர்பு தகவல்: தொடர்பு மற்றும் ஒப்புதல் சரிபார்ப்பை செயல்படுத்த கணக்கு பதிவின் போது வழங்கப்படும் மின்னஞ்சல் முகவரி அல்லது தொலைபேசி எண்.",
    childInfo:
      "குழந்தை தகவல்: கற்றல் அனுபவத்தை தனிப்பயனாக்க கணக்கு அமைப்பின் போது பெற்றோர் அல்லது பாதுகாவலர்களால் வழங்கப்படும் பெயர் மற்றும் வயது.",
    nonPersonalInformation: "தனிப்பட்ட அல்லாத தகவல்",
    nonPersonalInfoText: "பயன்பாட்டின் செயல்பாடு மற்றும் பயனர் அனுபவத்தை மேம்படுத்த தனிப்பட்ட அல்லாத தகவலை சேகரிக்கலாம். இதில் அடங்கும்:",
    deviceInfo: "சாதன தகவல்: சாதன வகை, இயக்க முறைமை மற்றும் தனித்துவமான சாதன அடையாளங்காட்டிகள்.",
    usageData:
      "பயன்பாட்டு தரவு: அணுகப்பட்ட அம்சங்கள், பயன்பாட்டில் செலவழித்த நேரம் மற்றும் கற்றல் முன்னேற்றம் உள்ளிட்ட பயன்பாடு எவ்வாறு பயன்படுத்தப்படுகிறது என்பது பற்றிய தகவல்.",
    howWeUseInfo: "தகவலை எவ்வாறு பயன்படுத்துகிறோம்",
    personalInfoUsage: "தனிப்பட்ட தகவல் பின்வரும் நோக்கங்களுக்காக மட்டுமே பயன்படுத்தப்படுகிறது:",
    accountManagement:
      "கணக்கு மேலாண்மை: பயனர் கணக்குகளை உருவாக்கி நிர்வகித்தல், பெற்றோரின் ஒப்புதலை சரிபார்த்தல் மற்றும் வாடிக்கையாளர் ஆதரவை வழங்குதல்.",
    personalization: "தனிப்பயனாக்கம்: குழந்தையின் வயது மற்றும் விருப்பங்களுக்கு ஏற்ப கற்றல் அனுபவத்தை தனிப்பயனாக்குதல்.",
    communication: "தொடர்பு: முக்கியமான புதுப்பிப்புகள் மற்றும் அறிவிப்புகளை பெற்றோர் அல்லது பாதுகாவலர்களுக்கு அனுப்புதல்.",
    nonPersonalInfoUsage: "தனிப்பட்ட அல்லாத தகவல் பயன்பாட்டை மேம்படுத்தவும் சிறந்த பயனர் அனுபவத்தை உறுதி செய்யவும் உதவுகிறது:",
    usageAnalysis:
      "பயன்பாட்டு போக்கு பகுப்பாய்வு: அம்சங்கள் மற்றும் செயல்பாட்டை மேம்படுத்த பயனர்கள் பயன்பாட்டுடன் எவ்வாறு தொடர்பு கொள்கிறார்கள் என்பதைப் புரிந்துகொள்வது.",
    technicalSupport: "தொழில்நுட்ப ஆதரவு: தொழில்நுட்ப சிக்கல்களை அடையாளம் கண்டு தீர்ப்பது.",
    researchDevelopment:
      "ஆராய்ச்சி மற்றும் மேம்பாடு: பயனர் நடத்தை மற்றும் கருத்துக்களின் அடிப்படையில் புதிய அம்சங்கள் மற்றும் கல்வி உள்ளடக்கத்தை உருவாக்குதல்.",
    dataSecurity: "தரவு பாதுகாப்பு",
    dataSecurityText:
      "உங்கள் குழந்தையின் தகவலைப் பாதுகாக்க நாங்கள் உறுதிபூண்டுள்ளோம். அங்கீகரிக்கப்படாத அணுகல், மாற்றம், வெளிப்படுத்தல் அல்லது அழிவுக்கு எதிராக தனிப்பட்ட தகவலைப் பாதுகாக்க தொழில்துறை-தரநிலை பாதுகாப்பு நடவடிக்கைகளை செயல்படுத்துகிறோம்.",
    parentalConsent: "பெற்றோரின் ஒப்புதல்",
    parentalConsentText:
      "13 வயதுக்குட்பட்ட குழந்தைகளின் தனிப்பட்ட தகவல்களை சேகரிக்க, பயன்படுத்த அல்லது வெளிப்படுத்துவதற்கு முன் சரிபார்க்கக்கூடிய பெற்றோரின் ஒப்புதல் தேவை.",
    emailConsent: "மின்னஞ்சல் ஒப்புதல்: மின்னஞ்சல் மூலம் கையொப்பமிடப்பட்ட ஒப்புதல் படிவத்தை அனுப்புதல்.",
    paymentConsent: "கட்டண ஒப்புதல்: அடையாளம் மற்றும் ஒப்புதலை சரிபார்க்க கிரெடிட் கார்டு பரிவர்த்தனையைப் பயன்படுத்துதல்.",
    consentForm: "ஒப்புதல் படிவம்: ஆன்லைன் ஒப்புதல் படிவத்தை நிரப்புதல்.",
    parentRights: "பெற்றோர்கள் எந்த நேரத்திலும் தங்கள் குழந்தையின் தனிப்பட்ட தகவலை மதிப்பாய்வு செய்ய, திருத்த அல்லது நீக்க உரிமை உள்ளது.",
    informationSharing: "தகவல் பகிர்வு",
    informationSharingText: "பின்வரும் சூழ்நிலைகளைத் தவிர, மூன்றாம் தரப்பினருடன் தனிப்பட்ட தகவலைப் பகிர்வதில்லை:",
    serviceProviders:
      "சேவை வழங்குநர்கள்: பயன்பாட்டை இயக்க உதவும் நம்பகமான மூன்றாம் தரப்பு சேவை வழங்குநர்கள், அவர்கள் எங்கள் தரவு பாதுகாப்பு கொள்கைகளுக்கு இணங்க வேண்டும்.",
    legalRequirements: "சட்ட தேவைகள்: சட்டத்தால் தேவைப்படும்போது அல்லது எங்கள் பயனர்களின் பாதுகாப்பு மற்றும் உரிமைகளைப் பாதுகாக்க.",
    thirdPartyLinks: "மூன்றாம் தரப்பு இணைப்புகள்",
    thirdPartyLinksText:
      "MiABC மூன்றாம் தரப்பு இணையதளங்கள் அல்லது சேவைகளுக்கான இணைப்புகள் கொண்டிருக்கலாம். இவை இந்த தனியுரிமைக் கொள்கையால் நிர்வகிக்கப்படவில்லை.",
    policyChanges: "இந்த தனியுரிமைக் கொள்கையில் மாற்றங்கள்",
    policyChangesText:
      "இந்த தனியுரிமைக் கொள்கையை அவ்வப்போது புதுப்பிக்கலாம். ஏதேனும் குறிப்பிடத்தக்க மாற்றங்கள் மின்னஞ்சல் மூலம் அல்லது பயன்பாட்டிற்குள் அறிவிப்பு மூலம் பெற்றோருக்கு அறிவிக்கப்படும்.",
    contactUs: "எங்களை தொடர்பு கொள்ளவும்",
    contactUsText: "இந்த தனியுரிமைக் கொள்கை குறித்து ஏதேனும் கேள்விகள் அல்லது கவலைகள் இருந்தால், தயவுசெய்து எங்களை தொடர்பு கொள்ளவும்:",
    email: "மின்னஞ்சல்",
    thankYou:
      "உங்கள் குழந்தையின் கற்றலுக்கு MiABC ஐ நம்பியதற்கு நன்றி. அனைத்து பயனர்களுக்கும் பாதுகாப்பான மற்றும் செறிவூட்டும் அனுபவத்தை உறுதி செய்ய நாங்கள் உறுதிபூண்டுள்ளோம்.",

    // Menu component
    dashboard: "முகப்பு பலகை",
    words: "சொற்கள்",
    added: "சேர்க்கப்பட்டது",
    received: "பெறப்பட்டது",
    sent: "அனுப்பப்பட்டது",
    family: "குடும்பம்",
    addedMembers: "சேர்க்கப்பட்ட உறுப்பினர்கள்",
    actions: "செயல்கள்",
    createText: "உரையை உருவாக்கவும்",
    textList: "உரை பட்டியல்",
    downloads: "பதிவிறக்கங்கள்",
    manageDownloads: "உங்கள் ஆதரவு ஆவணங்களை நிர்வகிக்கவும் மற்றும் பதிவிறக்கவும்",
    totalConnections: "மொத்த இணைப்புகள்",
    personalAudio: "தனிப்பட்ட ஆடியோ",
    personalAudioDescription: "உங்கள் குரல் மற்றும் தனிப்பயனாக்கப்பட்ட ஊக்கமளிக்கும் சொற்றொடர்கள்",
    welcomeBack: "மீண்டும் வருக",
    representative: "பெற்றோர் / பாதுகாவலர்",
    monitoringLearner: "நீங்கள் இவரின் முன்னேற்றத்தைப் பின்தொடர்கிறீர்கள்:",
    learnerBadge: "கற்பவர்",
    learnerProfileHint: "இது நீங்கள் ஆதரிக்கும் கற்பவரின் சுயவிவரம்.",
    manageSentWords: "நீங்கள் அனுப்பிய சொற்களை நிர்வகிக்கவும் மற்றும் பார்க்கவும்",
    noWords: "கிடைக்கக்கூடிய சொற்கள் எதுவுமில்லை",
    manageTexts: "உங்கள் வாசிப்பு உரைகளை நிர்வகிக்கவும் மற்றும் பார்க்கவும்",
    questions: "கேள்விகள்",
    questionSingular: "கேள்வி",
    perLevel: "/ நிலை",
    mixed: "கலப்பு",
    close: "மூடு",
    lessonNotFound: "பாடம் கிடைக்கவில்லை",
    noSavedLessons: "இன்னும் சேமிக்கப்பட்ட பாடங்கள் எதுவும் இல்லை.",
    errorDeleting: "நீக்குவதில் பிழை",
    savingImage: "படத்தைச் சேமித்து சேமித்து வைக்கிறது...",
    noTextsYet: "இன்னும் உரைகள் எதுவும் உருவாக்கப்படவில்லை.",
    downloadCompleteTitle: "பதிவிறக்கம் முடிந்தது!",
    downloadCompleteText: "கோப்பு வெற்றிகரமாகப் பதிவிறக்கப்பட்டது.",
    downloadingTitle: "கோப்புகள் பதிவிறக்கப்படுகின்றன",
    downloadingText: "அனைத்து கோப்புகளின் பதிவிறக்கம் தொடங்கியது",
    accept: "சரி",
    view: "காண்க",
    sessionStarted: "அமர்வு தொடங்கப்பட்டது:",
    userManual: "MiABC கையேடு",
    userGuide: "பயனர் வழிகாட்டி",
    userGuideSubtitle: "MiABC Online ஊடாடும் கையேடு",
    logout: "வெளியேறு",
    
    // Inference Learning
    inferenceLearning: "அனுமான கற்றல்",
    inferenceIdeaPlaceholder: "ஒரு யோசனையை எழுதுங்கள் (எ.கா: நிலவில் ஒரு விண்வெளி வீரர்)",
    generateInference: "உள்ளடக்கத்தை உருவாக்கவும்",
    pedagogicalObjective: "கற்பித்தல் நோக்கம்",
    vocabularyList: "சொற்களஞ்சியம்",
    inferenceQuestions: "அனுமான கேள்விகள்",
    generatingContent: "உள்ளடக்கத்தை உருவாக்குகிறது (DALL-E & Gemini)...",
    numQuestionsLabel: "கேள்விகளின் எண்ணிக்கை (1-5):",
    errorGenerating: "அனுமான உள்ளடக்கத்தை உருவாக்கும் போது பிழை ஏற்பட்டது.",
    inferenceReadingText: "வாசிப்பு உரை",
    discard: "நிராகரி",
    savedSuccessfully: "உள்ளடக்கம் வெற்றிகரமாக சேமிக்கப்பட்டது",
    errorSaving: "சேமிக்கும் போது பிழை ஏற்பட்டது",
    inferenceIdeaLabel: "பாடம் எதைப் பற்றி உருவாக்க விரும்புகிறீர்கள்?",
    savedLessonsTitle: "சேமிக்கப்பட்ட உள்ளடக்கங்கள்",
    deleteConfirmationTitle: "நீங்கள் உறுதியாக இருக்கிறீர்களா?",
    deleteConfirmationText: "இந்தச் செயலைச் செயல்தவிர்க்க முடியாது.",
    delete: "அழி",
    deletedSuccessfully: "பாடம் நீக்கப்பட்டது",
    cancel: "ரத்துசெய்",
    imageQuestionsTitle: "படம் பற்றிய கேள்விகள்",
    easy: "எளிதானது",
    medium: "நடுத்தர",
    hard: "கடினமான",
    textQuestionsSettings: "வாசிப்பு மற்றும் புரிதல் கேள்விகள் (ப்ளூமின் வகைபிரித்தல்)",
    bloomDifficultyHelp: "உரை மற்றும் சொல்லகராதி எவ்வளவு சிக்கலானதாக இருக்கும் என்பதை வரையறுக்கிறது.",
    visualQuestionsSettings: "காட்சி கவனிப்பு கேள்விகள்",
    visualDifficultyHelp: "மாணவர்களின் கவனிப்பு எவ்வளவு ஆழமாக இருக்க வேண்டும்.",
    visualQuestionsHelp: "உருவாக்கப்பட்ட படத்தை மட்டுமே அடிப்படையாகக் கொண்ட கேள்விகள்.",
  },
}

// Hook personalizado para obtener traducciones
export const useTranslations = () => {
  const { language } = useLanguage()

  const t = (key) => {
    return translations[language][key] || key
  }

  return { t, language }
}

// Función auxiliar para obtener traducción sin hook (para uso en componentes de clase)
export const getTranslation = (language, key) => {
  return translations[language][key] || key
}
